import { TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostListener, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import _ from 'lodash';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { PopupMessageComponent } from 'src/app/shared/components/popup-message/popup-message.component';
import { AuthorizePaymentType, buttonTypes, componentName, ComponentTypes, NoteType, PartyNoteTypes } from 'src/app/shared/constants/commonenums';
import { DynamicFormComponent } from 'src/app/shared/dynamicform/dynamic-form/dynamic-form.component';
import { ButtonValue, FieldConfig } from 'src/app/shared/dynamicform/models/common-models';
import { ComponentDetails } from 'src/app/shared/dynamicform/models/popup.interface';
import { DynamicFormService } from 'src/app/shared/dynamicform/service/dynamic-form.service';
import { BookingTypeQuantityDTO, CoverTypeQuantityDTO, CustomFieldsDTO, FinancialEffectForUpdatedReservationDTO, PartyNoteType, PaymentGateways, PaymentStates, RegisterReservationAttemptResponseDTO, SecondaryContactDTO } from 'src/app/shared/Models/PartyModels';
import { SlotLockResultDTO } from 'src/app/shared/Models/SlotLockModels';
import { ConfirmationVia, CountryDTO, operationType, PolicyDataType } from 'src/app/shared/Models/WidgetSettingsModels';
import { PopupService } from 'src/app/shared/services/popup.service';
import { Utilities } from 'src/app/shared/utilities/utilities';
import { environment } from 'src/environments/environment';
import { AuthRefundPopupComponent } from '../../shared/components/auth-refund-popup/auth-refund-popup.component';
import { DataRetentionPolicyComponent } from '../data-retention-policy/data-retention-policy.component';
import { LayoutService } from '../layout.service';
import { ReservationService } from '../reservation.service';
import { GuestService } from 'src/app/shared/services/guest.service';
import { HttpClient } from '@angular/common/http';
// Swire Change
import { FormChipService } from 'src/app/shared/dynamicform/components/form-chip/form-chip.service';
// Swire Change

@Component({
  selector: 'app-guest-details',
  templateUrl: './guest-details.component.html',
  styleUrls: ['./guest-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Default
})
export class GuestDetailsComponent extends Utilities implements OnInit, OnDestroy {
  guestInfoConfig: FieldConfig[];
  guestInfoConfigSecondary: FieldConfig[];
  guestConfig: FieldConfig[];
  confirmButton: ButtonValue;
  previousButton: ButtonValue;
  editButton: ButtonValue;
  editGuestButton: ButtonValue;
  editSlotsButton: ButtonValue;
  additionalGuestBtn: ButtonValue;
  guestDetailsForm: FormGroup;
  guestDataPrimary = ['primaryGuest'];
  guestDataSecondary = ['secondaryGuest1'];
  guestData = [];
  @ViewChildren('form') components: QueryList<DynamicFormComponent>;
  @ViewChild('d') primaryGuest: DynamicFormComponent;
  partySize = 5;
  subscriptions: Subscription = new Subscription();
  partyDetails: any;
  lockResult: SlotLockResultDTO;
  deleteSecondaryGuestPopUpRef: MatDialogRef<any>;
  paymentData: RegisterReservationAttemptResponseDTO;
  urlSafe: SafeResourceUrl;
  waiverFormTrancationId = null;
  isUserAllowedToclickConfirm = false;
  stopListening: Function;
  showIframe = false;
  IframeURL = '';
  waiverFormTransactionId = '';
  countryCodes: CountryDTO[] = [];
  selectedCountryId: number;
  noShowfeeMessage = '';
  noShowfee: number;
  activityPayment: number;
  paymentWithoutTax: number;
  paymentMessage = '';
  notesFormGroup: any;
  dataRetentionPolicyExisting = false;
  primaryGuestPhone = '';
  primaryGuestEmail = '';
  dataRetentionPolicyDialogRef: MatDialogRef<any>;
  financialPopUpRef: MatDialogRef<any>;
  popUpMessage = '';
  noShowPolicyTitle = '';
  ratePlanAmountInfo: number;
  specialMealAmountInfo: number;
  paymentAmountInfo: number;
  operationType = operationType;
  freeTextIdList = [];
  secondaryGuestTobeDeletedIndex: number;
  noteType: number;
  canShowSeatingType = false;
  isPreReservationMsgHTML = false;
  financialData: FinancialEffectForUpdatedReservationDTO;
  isSplitPayment: boolean;
  RefundData: any;
  AuthrefundPopupRef: any;
  isAuthRefund: boolean;
  SwireConfig: any;
  customGuestFieldsMappingValidations: any[] = [];
  serviceCharge = 0.0;
  taxOnServiceCharge = 0.0;
  // Swire Change
  selectedPartyNotes: any[] = [];
  selectedPartyPreferenceTags: any[] = [];
  isForSwire: boolean;
  // Swire Change
  authorizeTransactionDetails: any;
  isFormValid: boolean = false;
  validationMessageList: string[] = [];
  nextButton: ButtonValue;

  constructor(private ts: TranslateService, private dfs: DynamicFormService, public ls: LayoutService, 
              private fb: FormBuilder, public rs: ReservationService, public sanitizer: DomSanitizer, 
              private ps: PopupService, public dialog: MatDialog, public titleCasePipe: TitleCasePipe, 
              public gs: GuestService, private formChipService: FormChipService, private http: HttpClient) {
    super(dialog)
  }

  ngOnInit(): void {
    this.SwireConfig = environment["NotesAsTagsMerchantIds"];
    this.guestDetailsForm = this.fb.group({})
    this.authorizeTransactionDetails = null;
    this.countryCodes = this.ls.countriesList;
    if(this.ls.restaurantWidgetSettings$.value.DisableCustomTermsAndConditions && !this.isSwireAndSEAEnv()) {
      if (this.ls.restaurantWidgetSettings$.value.WidgetCustomization.CustomTermsOfService && this.ls.restaurantWidgetSettings$.value.WidgetCustomization.CustomTermsOfService.length > 0) {
        this.validationMessageList.push(this.ts.instant('By click next, you agree to the following'));
        this.validationMessageList.push(`<a class="link-url" href="${'/Terms_Of_Use/restaurants/' + this.ls.restaurantWidgetName }" target="_blank">${this.ts.instant('termsOfUse')}</a>` + this.ts.instant('and') + `<a class="link-url" href="${'/Privacy_Policy/restaurants/' + this.ls.restaurantWidgetName}" target="_blank" >${this.ts.instant('privacyPolicy')}</a>`)
        this.ls.restaurantWidgetSettings$.value.WidgetCustomization.CustomTermsOfService.forEach((customTerm) => {
          this.validationMessageList.push(customTerm);
        });
      }
      else {
        this.validationMessageList.push(this.getAgreeTermsAndConditionsText());
      }
    }
    this.noteType = this.ls.restaurantWidgetSettings$.value.WidgetCustomization.NotesType;
    if(this.ls.restaurantWidgetSettings$.value?.customGuestFieldsMappingValidations){
      this.customGuestFieldsMappingValidations = this.ls.restaurantWidgetSettings$.value?.customGuestFieldsMappingValidations
    }
    this.CheckForSwire();
    this.createGuestConfig();
    if (this.ls.restaurantWidgetSettings$.value.WidgetCustomization.PreReservationMessage) {
      let preReservationMsg = this.ls.restaurantWidgetSettings$.value.WidgetCustomization.PreReservationMessage;
      const HTMLPattern = /<(?=.*? .*?\/ ?>|br|hr|input|!--|wbr)[a-z]+.*?>|<([a-z]+).*?<\/\1>/i;
      this.isPreReservationMsgHTML = HTMLPattern.test(preReservationMsg);
    }
    //  this.addCategoryPreferencesNotes(this.noteType);
    let guestConfigCopy = _.cloneDeep(this.guestConfig);
    if (this.rs.additionalGuestPage && this.ls.operation != operationType.edit) {
      this.addCategoryPreferencesNotes(NoteType.guestNote);
      this.guestData = _.cloneDeep(this.guestDataSecondary)
      this.guestInfoConfig = _.cloneDeep(this.guestConfig)
    }
    else if (!this.rs.additionalGuestPage && this.ls.operation == operationType.edit) {
      this.guestData = _.cloneDeep(this.guestDataPrimary);

      let partySize = this.ls.operation == operationType.edit && this.rs.secondaryContactList ? this.rs.secondaryContactList.length : 0;//this.rs.reservationFormGroup.controls.guestDetailsForm.get('secondaryContactList').value.length
      while (partySize != 0) {
        this.guestData.push(this.ts.instant('secondaryGuest') + (this.guestData.length + 1));
        partySize--;
      }
      this.addCategoryPreferencesNotes(this.noteType);

      // Swire Change
      if (this.isForSwire) {
        this.mapPartyNotes();
      }
      // Swire Change

      this.guestInfoConfig = _.cloneDeep(this.guestConfig);
      this.addCustomGuestFields();
      this.addRequiredCustomTermsAndConditions();
      this.createGuestConfig();
      this.addCategoryPreferencesNotes(NoteType.guestNote);
      this.guestInfoConfigSecondary = _.cloneDeep(this.guestConfig);
      this.guestInfoConfigSecondary.forEach((config) => {
        if (config.name == 'region' || config.name == 'phone') {
          config.disableSelect = true;
        }
      });
      // this.guestInfoConfigSecondary[2].disableSelect = true;
      // this.guestInfoConfigSecondary[3].disableSelect = true;
    }
    else {
      this.addCategoryPreferencesNotes(this.noteType);

      // Swire Change
      if (this.isForSwire) {
        this.mapPartyNotes();
      }
      // Swire Change

      this.guestData = _.cloneDeep(this.guestDataPrimary)
      this.guestInfoConfig = _.cloneDeep(this.guestConfig);
    }

    if (this.countryCodes && this.countryCodes.length > 0) {
      let countrySelected = Utilities.getDefaultCountry(this.countryCodes, this.ls.restaurantWidgetSettings$.value.Country);
      this.guestInfoConfig.forEach((config) => {
        if (config.name == 'region' || config.name == 'phone') {
          config.options = [];
        }
      });
      // this.guestInfoConfig[2].options = [];
      // this.guestInfoConfig[3].options = [];
      this.countryCodes.forEach(element => {
        this.guestInfoConfig.forEach((config) => {
          if (config.name == 'region') {
            config.options.push({ id: element.Id, value: element.Name });
          } else if (config.name == 'phone') {
            config.options.push({ id: element.Id, value: element.CountryPhoneCode });
          }
        });
        // this.guestInfoConfig[2].options.push({ id: element.Id, value: element.Name });
        // this.guestInfoConfig[3].options.push({ id: element.Id, value: element.CountryPhoneCode });
      })
      if (this.rs.primaryContact) {
        const selectedCountryCode = this.countryCodes.filter((country) => {
          return country.Id === this.rs.primaryContact.CountryId;
        })[0];
        if (selectedCountryCode) {
          this.rs.selectedCountryId = selectedCountryCode.Id;
          this.dfs.selectedCountryCode = selectedCountryCode.CountryPhoneCode;
          this.dfs.selectedCountryId = selectedCountryCode.Id;
        }
      }
      this.guestInfoConfig.forEach((config) => {
        if (config.name == 'region' || config.name == 'phone') {
          config.value = this.rs.selectedCountryId ? this.rs.selectedCountryId : countrySelected.Id;
        }
      });
      // this.guestInfoConfig[2].value = this.rs.selectedCountryId ? this.rs.selectedCountryId : countrySelected.Id;
      // this.guestInfoConfig[3].value = this.rs.selectedCountryId ? this.rs.selectedCountryId : countrySelected.Id;
      if (operationType.edit == this.ls.operation && this.guestInfoConfigSecondary) {
        this.guestInfoConfigSecondary.forEach((config) => {
          if (config.name == 'region' || config.name == 'phone') {
            let configOptions = this.guestInfoConfig.filter((guestConfig) => guestConfig.name == config.name);
            if (configOptions && configOptions.length) {
              config.options = _.cloneDeep(configOptions[0].options);
            }
            config.value = this.rs.selectedCountryId ? this.rs.selectedCountryId : countrySelected.Id;
          }
        });
        // this.guestInfoConfigSecondary[2].options = _.cloneDeep(this.guestInfoConfig[2].options);
        // this.guestInfoConfigSecondary[2].value = this.rs.selectedCountryId ? this.rs.selectedCountryId : countrySelected.Id;
        // this.guestInfoConfigSecondary[3].options = _.cloneDeep(this.guestInfoConfig[3].options);
        // this.guestInfoConfigSecondary[3].value = this.rs.selectedCountryId ? this.rs.selectedCountryId : countrySelected.Id;
      }
      this.rs.selectedCountryId = this.rs.selectedCountryId ? this.rs.selectedCountryId : countrySelected.Id;
      this.dfs.selectedCountryCode = this.dfs.selectedCountryCode ? this.dfs.selectedCountryCode : countrySelected.CountryPhoneCode;
      this.dfs.selectedCountryId = this.dfs.selectedCountryId ? this.dfs.selectedCountryId : countrySelected.Id;
    }
    this.createActionButtons();
    this.partyDetails = this.ls.editPartyData = _.cloneDeep(this.rs.reservationFormGroup.controls.reservationDetailsForm.value);

    if (!this.rs.additionalGuestPage) {
      if (this.ls.operation != operationType.edit) {
        this.addCustomGuestFields();
        this.addRequiredCustomTermsAndConditions();
      }
      this.ls.operation == operationType.edit ? this.RegisterReservationAttempt(true) : this.GetPreliminaryReservationInformation();
    }
    else {
      this.isUserAllowedToclickConfirm = true;
    }

    this.subscriptions.add(this.ps.actionEnabled$.subscribe(from => {
      if (from == ComponentTypes.dataRetentionPolicy) {
        if (this.dataRetentionPolicyDialogRef) {
          this.dataRetentionPolicyDialogRef.close();
        }
      }
      else if (from == ComponentTypes.deleteSecondaryGuest) {
        this.deleteSecondaryGuestConfirmed();
        this.deleteSecondaryGuestPopUpRef.close();
      }
      else if (from == ComponentTypes.financialEffectCalculation) {
        this.financialPopUpRef.close();
        if (this.RefundData) {
          this.showAuthRefundPopup();
        }
      }
      else if (from == ComponentTypes.AuthRefundPopup) {
        this.AuthrefundPopupRef.close();
        this.isAuthRefund = true;
      }
    }));

    this.subscriptions.add(this.ps.cancelEnabled$.subscribe(from => {
      if (from == ComponentTypes.financialEffectCalculation || from == ComponentTypes.AuthRefundPopup) {
        this.goBackToReservation();
      }
      if (from == ComponentTypes.deleteSecondaryGuest) {
        this.deleteSecondaryGuestPopUpRef.close();
      }
    }));

    // Swire Change
    if (this.isForSwire) {
      this.formChipsChange();
    }
    // Swire Change
    // this.canShowSeatingType = !(environment.SEAProduction && environment.restaurantIds.filter(x=> x == this.ls.restaurantWidgetSettings$.value.RestaurantId).length > 0);
  
    this.subscriptions.add(
      this.gs.overlapBookingproceedEvent.subscribe(x=>{
        if(x.proceedOverlapBooking) {
          this.reservationConfirm();
        }
      })
    )

  }
  
  isHTML(str) {
    var doc = new DOMParser().parseFromString(str, "text/html");
    return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
  }
  
  createGuestConfig() {
    this.guestConfig = [
      {
        type: 'input',
        label: 'firstName',
        name: 'firstName',
        inputType: 'text',
        class: 'guest-details__first-name',
        showErrorText: true,
        appearance: true,
        isFormArray: false,
        errorMessage: 'firstNameRequired',
        validation: [Validators.required, Validators.minLength(this.ls?.restaurantWidgetSettings$?.value?.ContactMinLength ?? 2)],
        charLength: this.ls?.restaurantWidgetSettings$?.value?.ContactMinLength ?? 2,
        value: ''
      },
      {
        type: 'input',
        label: 'lastName',
        name: 'lastName',
        inputType: 'text',
        class: 'guest-details__last-name',
        showErrorText: true,
        appearance: true,
        isFormArray: false,
        errorMessage: 'lastNameRequired',
        validation: [Validators.required , Validators.minLength(this.ls?.restaurantWidgetSettings$?.value?.ContactMinLength ?? 2)],
        charLength:this.ls?.restaurantWidgetSettings$?.value?.ContactMinLength ?? 2,
        value: ''
      },
      {
        type: 'input',
        label: 'aliasName',
        name: 'aliasName',
        inputType: 'text',
        class: 'guest-details__alias-name',
        showErrorText: true,
        appearance: true,
        isFormArray: false,
        value: '',
        hide: this.ls.restaurantWidgetSettings$.value?.ShowAliasName ? false : true
      },
      {
        type: 'select',
        name: 'region',
        placeholder: '',
        options: [],
        appearance: true,
        isFormArray: false,
        label: 'region',
        class: "guest-details__region",
        validation: [Validators.required],
        cellClick: this.regionChange.bind(this),
        disableSelect: this.rs.additionalGuestPage,        
        isNativeControl: this.ls.isMobileBrowser
      },
      {
        type: 'inputSelect',
        label: 'phone',
        name: 'phone',
        inputType: 'text',
        placeholder: 'registerPinText',
        class: 'guest-details__phone',
        showErrorText: true,
        appearance: true,
        errorMessage: 'phoneRequired',
        isFormArray: false,
        cellClick: this.countryCodeSelected.bind(this),
        isPhoneNumber: true,
        validation: [Validators.required],
        disableSelect: true,
        blurClick: this.mobileNumberValidation.bind(this)
      },
      {
        type: 'input',
        label: 'email',
        name: 'email',
        inputType: 'email',
        class: 'guest-details__email',
        showErrorText: true,
        appearance: true,
        isFormArray: false,
        errorMessage: 'emailRequired',
        validation: [Validators.required, Validators.email, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$')],
        value: ''
      }
    ];
  }

  createActionButtons() {
    this.confirmButton = {
      type: buttonTypes.confirmBtn,
      label: 'confirm',
      customclass: 'guest-details__confirm-btn',
      disbaledproperity: true
    };
    this.editButton = {
      type: buttonTypes.confirmBtn,
      label: 'edit',
      customclass: 'guest-details__confirm-btn',
      disbaledproperity: false
    };
    this.previousButton = {
      type: buttonTypes.cancelBtn,
      label: 'previous',
      customclass: 'guest-details__previous-btn',
    };
    this.additionalGuestBtn = {
      type: buttonTypes.cancelBtn,
      label: this.ts.instant('guestDetails'),
      customclass: 'guest-details__additional-guest',
      icon: 'icon-add'
    };
    this.nextButton =  {
      type: buttonTypes.confirmBtn,
      label: 'next',
      customclass: 'guest-details__next-btn',
      disbaledproperity: false
    };
    this.editSlotsButton = {
      type: buttonTypes.confirmBtn,
      label: 'editSlots',
      customclass: 'guest-details__confirm-btn',
      disbaledproperity: false
    };
    this.editGuestButton = {
      type: buttonTypes.confirmBtn,
      label: 'editGuest',
      customclass: 'guest-details__confirm-btn',
      disbaledproperity: false
    };
  }

  addCategoryPreferencesNotes(noteType: NoteType) {
    if (this.ls.restaurantWidgetSettings$.value.PreferencesCategories && this.ls.restaurantWidgetSettings$.value.PreferencesCategories.length > 0) {
      this.ls.restaurantWidgetSettings$.value.PreferencesCategories.forEach(category => {
        if (category.IncludeInWebReservation) {
          let predefinedNotes = [];
          let freeTextIdValue;
          if (category.SubCategories && category.SubCategories.length > 0) {
            category.SubCategories.forEach(x => {
              if (noteType == NoteType.guestNote && x.PredefinedContactNote && x.PredefinedContactNote.length > 0) {
                x.PredefinedContactNote.forEach(note => {
                  if (note.Text.toLowerCase() == "others") {
                    freeTextIdValue = note.Id;
                    this.freeTextIdList.push(freeTextIdValue);
                  } else {
                    let predefinedContactNoteMappingList = note.PredefinedContactNotePropertyMapping.filter(x => x.PropertyId == this.ls.restaurantWidgetSettings$.value.RestaurantId).map(x => x.PredefinedContactNoteId);
                   if (predefinedContactNoteMappingList.find(x => x == note.Id)) { predefinedNotes.push(note) }
                  }
                });
              }
              else if (noteType == NoteType.partyNote && x.PredefinedPartyNote && x.PredefinedPartyNote.length > 0) {
                x.PredefinedPartyNote.forEach(note => {
                  if (note.Text.toLowerCase() == "others") {
                    freeTextIdValue = note.Id;
                    this.freeTextIdList.push(freeTextIdValue);
                  } else {
                    let predefinedPartyNoteMappingList = note.PredefinedPartyNotePropertyMapping.filter(x => x.PropertyId == this.ls.restaurantWidgetSettings$.value.RestaurantId).map(x => x.PredefinedPartyNoteId);
                    if (predefinedPartyNoteMappingList.find(x => x == note.Id)) { predefinedNotes.push(note) }
                  }
                });
              }
              this.freeTextIdList = _.uniq(this.freeTextIdList);
            })
          };
          if (predefinedNotes && predefinedNotes.length > 0) {
            // Swire Change
            if (this.isForSwire) {
              const tag = {
                type: 'chip',
                name: 'preferences_' + category.Id.toString(),
                inputType: 'text',
                label: category.Text,
                options: this.getOptions(predefinedNotes),
                multipleChip: true,
                isFormArray: true
              }
              this.guestConfig.push(tag);
            }
            // Swire Change
            else {
              let options = predefinedNotes.map(x => { return { id: x.Id, value: x.Text } });
              this.guestConfig.push({
                type: 'checkbox',
                placeholder: 'ds',
                value: false,
                name: 'preferences_' + category.Id.toString(),
                groupLabel: category.Text,
                options: options,
                isFormArray: true,
                class: 'guest-details__special-requests'
              })
            }

            if (freeTextIdValue) {
              let freeTextValue = ''
              if (!this.rs.additionalGuestPage && this.rs.primaryContact && this.rs.primaryContact.Notes && this.rs.primaryContact.Notes.length > 0) {
                if (this.rs.primaryContact.Notes.filter(x => x.RelatedId == freeTextIdValue)[0]) {
                  freeTextValue = this.rs.primaryContact.Notes.filter(x => x.RelatedId == freeTextIdValue)[0].Text;
                }
              }
              this.guestConfig.push({
                type: 'textarea',
                name: freeTextIdValue.toString(),
                class: 'guest-details__special-notes',
                label: 'Others',
                appearance: true,
                isFormArray: false,
                value: ''
              })
            }
          }
        }
      });
    }
  }

  // Swire Change
  getOptions(predefinedNotes): any {
    let configOptios = [];
    predefinedNotes.forEach((notes) => {
      configOptios.push({
        Id: notes.Id,
        Name: notes.Text,
        Icon: 'None',
        Value: '',
        color: this.ls.restaurantWidgetSettings$.value.WidgetCustomization.PrimaryButtonBGColor
      });
    })
    return configOptios;
  }

  CheckForSwire() {
    this.isForSwire = false;
    let swireMerchantIds: number[] = this.SwireConfig;
    
    swireMerchantIds?.forEach(id => {
         if (this.ls.restaurantWidgetSettings$.value.PreferencesCategories.find(cat => cat.MerchantId == id)) {
        this.isForSwire = true;
      }
    });
  }
  
  formChipsChange() {
    this.subscriptions.add(this.formChipService.formChipChange$.subscribe((selectedChips) => {
      if (this.guestInfoConfig.filter((fieldConfig) => fieldConfig.name == selectedChips.name).length > 0) {

        let choosenTag = selectedChips.data;
        
        choosenTag.forEach((_partyNotes) => {
          if (!(this.selectedPartyNotes[selectedChips.name])) {
            this.selectedPartyNotes[selectedChips.name] = []
          }

          if (_partyNotes.setSelected && !this.selectedPartyNotes[selectedChips.name].some((sNotes) => sNotes.Id == _partyNotes.Id)) {
            this.selectedPartyNotes[selectedChips.name].push(_partyNotes);
          }
          else if (!_partyNotes.setSelected && this.selectedPartyNotes[selectedChips.name].some((sNotes) => sNotes.Id == _partyNotes.Id)) {
            var index = this.selectedPartyNotes[selectedChips.name].findIndex((sNotes) => sNotes.Id == _partyNotes.Id);
            if(index !== -1)
              this.selectedPartyNotes[selectedChips.name].splice(index, 1);
              }
        })

        if (this.selectedPartyNotes[selectedChips.name].length == 0) {
          this.selectedPartyPreferenceTags[selectedChips.name] = this.selectedPartyNotes[selectedChips.name].reduce((acc, cur) => ({ ...acc, [cur.Id]: false }), {});
        }

        this.selectedPartyPreferenceTags[selectedChips.name] = this.selectedPartyNotes[selectedChips.name].reduce((acc, cur) => ({ ...acc, [cur.Id]: true }), {});
      }
    }));
  }

  mapPartyNotes() {
    const preferredTags = this.guestConfig.filter((fieldConfig) => fieldConfig.name.includes('preferences_'));
    if (!!(this.rs.reservationFormGroup.controls.guestDetailsForm)) {
      let primaryGuest = this.rs.reservationFormGroup.controls.guestDetailsForm.get('primaryGuest').value;

      preferredTags.forEach((fieldConfig) => {
        let data = primaryGuest[fieldConfig.name][0];
        let arrVal = Object.entries(data).map(([key, value]) => ({ key, value }));

        if (!!(data)) {
          arrVal.forEach((note) => {
            if (note.value) {
              const filteredNotes = fieldConfig.options.find(data => note.key == data.Id.toString());
              if (filteredNotes) {
                filteredNotes.setSelected = true;
                if (!(this.selectedPartyNotes[fieldConfig.name])) {
                  this.selectedPartyNotes[fieldConfig.name] = []
                }
                this.selectedPartyNotes[fieldConfig.name].push(filteredNotes);
              }
            }
          })

          if (this.selectedPartyNotes[fieldConfig.name] != null && this.selectedPartyNotes[fieldConfig.name] != undefined) {
            this.selectedPartyPreferenceTags[fieldConfig.name] = this.selectedPartyNotes[fieldConfig.name].reduce((acc, cur) => ({ ...acc, [cur.Id]: true }), {});
          }
        }
      });
      this.guestConfig = [...this.guestConfig];
    }
  }
  // Swire Change

  getCategoryPreferencesNotes(formValue, noteType: NoteType, secondaryContactId = null, isForSecondaryContact = false) {
    let notes = [];
    if(!formValue) return notes;
    if (this.ls.restaurantWidgetSettings$.value.PreferencesCategories && this.ls.restaurantWidgetSettings$.value.PreferencesCategories.length > 0) {
      this.ls.restaurantWidgetSettings$.value.PreferencesCategories.forEach(category => {

        // Swire Change
        if (this.isForSwire) {
          let userSelectedPartyPreference = [this.selectedPartyPreferenceTags['preferences_' + category.Id]];

          if (!!(userSelectedPartyPreference[0])) {
            formValue['preferences_' + category.Id] = userSelectedPartyPreference;
          }
        }
        // Swire Change

        let predefinedNotes = []
        if (formValue['preferences_' + category.Id.toString()]) {
          let userSelectedPredefinedNotesList = formValue['preferences_' + category.Id.toString()][0];
          if (category.SubCategories && category.SubCategories.length > 0) {
            category.SubCategories.forEach(x => {
              if (noteType == NoteType.guestNote && x.PredefinedContactNote && x.PredefinedContactNote.length > 0) {
                x.PredefinedContactNote.forEach(note => { predefinedNotes.push(note) });
              }
              else if (noteType == NoteType.partyNote && x.PredefinedPartyNote && x.PredefinedPartyNote.length > 0) {
                x.PredefinedPartyNote.forEach(note => { predefinedNotes.push(note) });
              }
            })
          };
          if (predefinedNotes && predefinedNotes.length > 0) {
            let existingNoteId;
            predefinedNotes.forEach(note => {
              if (noteType == NoteType.guestNote && this.ls.operation == operationType.edit ) {
                existingNoteId = isForSecondaryContact ? secondaryContactId ? this.ls.editPartyData$.value.BookingContacts?.find(sc=>sc.Id == secondaryContactId)?.Notes?.filter(x=>x.RelatedId == note.Id)[0]  : null
                                                    : this.ls.editPartyData$.value.Contact.Notes?.filter(x => x.RelatedId == note.Id)[0];
              }
              else if (noteType == NoteType.partyNote && this.ls.operation == operationType.edit ) {
                existingNoteId = isForSecondaryContact ? null : this.ls.editPartyData$.value.Notes.filter(x => x.RelatedId == note.Id)[0];
              }
              if (userSelectedPredefinedNotesList[note.Id.toString()] && noteType == NoteType.guestNote) {
                notes.push({
                  RelatedId: note.Id,
                  Text: note.Text,
                  Id: existingNoteId && existingNoteId.Id ? existingNoteId.Id : null,
                  Icon: note.Icon
                });
              }
              else if (userSelectedPredefinedNotesList[note.Id.toString()] && noteType == NoteType.partyNote) {
                notes.push({
                  RelatedId: note.Id,
                  Text: note.Text,
                  Id: existingNoteId && existingNoteId.Id ? existingNoteId.Id : null,
                  Type: PartyNoteTypes.PredefinedNote,
                  Icon: note.Icon
                });
              }
            })
          }
        }
      })

      if (this.freeTextIdList && this.freeTextIdList.length > 0) {
        this.freeTextIdList.forEach(freeTextId => {
          let existingNoteId: any = this.ls.operation == operationType.edit && this.ls.editPartyData$.value.Contact.Notes && this.ls.editPartyData$.value.Contact.Notes.length > 0 ? this.ls.editPartyData$.value.Contact.Notes.filter(x => x.RelatedId == freeTextId)[0] : '';
          if (noteType == NoteType.guestNote && operationType.edit && this.ls.editPartyData$.value.Contact.Notes && this.ls.editPartyData$.value.Contact.Notes.length > 0) {
            existingNoteId = this.ls.editPartyData$.value.Contact.Notes.filter(x => x.RelatedId == freeTextId)[0];
          }
          else if (noteType == NoteType.partyNote && operationType.edit && this.ls.editPartyData$.value.Notes && this.ls.editPartyData$.value.Notes.length > 0) {
            existingNoteId = this.ls.editPartyData$.value.Notes.filter(x => x.RelatedId == freeTextId)[0];
         }
          else {
            existingNoteId = '';
          }

          if (formValue[freeTextId.toString()] && noteType == NoteType.guestNote) {
            notes.push({
              RelatedId: freeTextId,
              Text: formValue[freeTextId.toString()],
              Id: existingNoteId && existingNoteId.Id ? existingNoteId.Id : null
            });
          }
          else if (formValue[freeTextId.toString()] && noteType == NoteType.partyNote) {
            notes.push({
              RelatedId: freeTextId,
              Text: formValue[freeTextId.toString()],
              Id: existingNoteId && existingNoteId.Id ? existingNoteId.Id : null,
              Type: PartyNoteType.FreeFormNote
            });
          }
        });
      }
    }
    return notes;
  }

  regionChange(eve) {
    this.countryCodeSelected(eve);
  }

  mobileNumberValidation(event?) {
    this.components.toArray().forEach(formData => {
      const phoneValue = formData.form.get('phone').value;
      let phoneNumber: any;
      if (formData.form.get('phone').value && formData.form.get('phone').value.length > 0) {
        phoneNumber = this.dfs.onInputChange(phoneValue ? phoneValue : event.value, false);
        formData.form.get('phone').setValue(phoneNumber);
      }
    });

    if (this.dfs.requiredPhoneNumberLength$) {
      const count = this.dfs.requiredPhoneNumberLength$;
      this.components.first.form.get('phone').setValidators([Validators.required, Validators.minLength(count), Validators.maxLength(count)]);
      this.guestDetailsForm.get('primaryGuest')['controls']['phone'].setValidators([Validators.required, Validators.minLength(count), Validators.maxLength(count)]);
      this.components.first.form.get('phone').updateValueAndValidity();
      this.guestDetailsForm.get('primaryGuest')['controls']['phone'].updateValueAndValidity();
      this.components.toArray().forEach((formData, index) => {
        if (index > 0) {
          formData.form['controls']['phone'].setValidators([Validators.minLength(count), Validators.maxLength(count)]);
          if (formData.form.value.phone && formData.form.value.phone.length > 0) {
            let phoneValue = this.dfs.onInputChange(formData.form.value.phone, false);
            formData.form.controls.phone.setValue(phoneValue);
          }
          formData.form['controls']['phone'].updateValueAndValidity();
        }
      });
    } else {
      this.components.first.form.get('phone').setValidators([Validators.required]);
      this.guestDetailsForm.get('primaryGuest')['controls']['phone'].setValidators([Validators.required]);
      this.components.first.form.get('phone').updateValueAndValidity();
      this.guestDetailsForm.get('primaryGuest')['controls']['phone'].updateValueAndValidity();
      this.components.toArray().forEach((formData, index) => {
        if (index > 0) {
          formData.form['controls']['phone'].setValidators([Validators.required]);
          if (formData.form.value.phone && formData.form.value.phone.length > 0) {
            let phoneValue = this.dfs.onInputChange(formData.form.value.phone, false);
            formData.form.controls.phone.setValue(phoneValue);
          }
          formData.form['controls']['phone'].updateValueAndValidity();
        }
      });
    }
  }

  countryCodeSelected(eve) {
    let countryValue = eve.value ? eve.value : eve.target.value;
    const selectedCountryCode = this.countryCodes.filter((country) => {
      return country.Id == countryValue;
    })[0];
    this.rs.selectedCountryId = selectedCountryCode.Id;
    this.dfs.selectedCountryCode = selectedCountryCode.CountryPhoneCode;
    this.dfs.selectedCountryId = selectedCountryCode.Id;
    this.guestInfoConfig[4].value = this.rs.selectedCountryId;
    this.guestInfoConfig = [...this.guestInfoConfig];
    this.components.toArray().forEach(formData => {
      const phoneValue = formData.form.get('phone').value;
      let phoneNumber: any;
      if (formData.form.get('phone').value && formData.form.get('phone').value.length > 0) {
        phoneNumber = this.dfs.onInputChange(phoneValue ? phoneValue : countryValue, false);
        formData.form.get('phone').setValue(phoneNumber);
      }
    });

    if (operationType.edit == this.ls.operation && this.guestInfoConfigSecondary) {
      this.guestInfoConfigSecondary.forEach((config) => {
        if (config.name == 'region' || config.name == 'phone') {
          config.value = this.rs.selectedCountryId ? this.rs.selectedCountryId : selectedCountryCode.Id;
        }
      });
    }
    if (this.dfs.requiredPhoneNumberLength$) {
      const count = this.dfs.requiredPhoneNumberLength$;
      this.components.first.form.get('phone').setValidators([Validators.minLength(count), Validators.maxLength(count)]);
      this.guestDetailsForm.get('primaryGuest')['controls']['phone'].setValidators([Validators.minLength(count), Validators.maxLength(count)]);
      this.components.first.form.get('phone').updateValueAndValidity();
      this.guestDetailsForm.get('primaryGuest')['controls']['phone'].updateValueAndValidity();
      this.components.toArray().forEach((formData, index) => {
        if (index > 0) {
          formData.form['controls']['phone'].setValidators([Validators.minLength(count), Validators.maxLength(count)]);
          if (formData.form.value.phone && formData.form.value.phone.length > 0) {
            let phoneValue = this.dfs.onInputChange(formData.form.value.phone, false);
            formData.form.controls.phone.setValue(phoneValue);
          }
          formData.form['controls']['phone'].updateValueAndValidity();
          if(countryValue && formData.form.value.region != countryValue) {
            formData.form.controls.region.setValue(countryValue);
            formData.form['controls']['region'].updateValueAndValidity();
          }
        }
      });
    }
    else {
      this.components.first.form.get('phone').clearValidators();
      this.guestDetailsForm.get('primaryGuest')['controls']['phone'].clearValidators();
      this.components.first.form.get('phone').updateValueAndValidity();
      this.guestDetailsForm.get('primaryGuest')['controls']['phone'].updateValueAndValidity();
    }
  }

  addCustomGuestFields() {
    let promoCodeValue = '';
    if (this.ls.operation == operationType.edit && this.ls.editPartyData$.value.Notes && this.ls.editPartyData$.value.Notes.length > 0) {
      this.ls.editPartyData$.value.Notes.forEach(note => {
        if (note.Type == PartyNoteType.PromoCode && note.Text) {
          promoCodeValue = note.Text;
        }
      });
    }

    if (this.ls.restaurantWidgetSettings$.value.WidgetCustomization.DisplayPromoCode) {
      this.guestInfoConfig.push(
        {
          type: 'input',
          label: this.ls.restaurantWidgetSettings$.value.WidgetCustomization.PromoCodeLabel ? this.ls.restaurantWidgetSettings$.value.WidgetCustomization.PromoCodeLabel : 'promoCode',
          value: promoCodeValue ? promoCodeValue : '',
          name: 'promocode',
          placeholder: this.ls.restaurantWidgetSettings$.value.WidgetCustomization.PromoCodeLabel ? this.ls.restaurantWidgetSettings$.value.WidgetCustomization.PromoCodeLabel : 'promoCode',
          class: 'guest-details__promo-code',
          appearance: true,
          isFormArray: false,
        });
    }


    if (this.ls.customGuestFields && this.ls.customGuestFields.CustomGuestField && this.ls.customGuestFields.CustomGuestField.length > 0) {
      this.ls.customGuestFields.CustomGuestField = _.sortBy(this.ls.customGuestFields.CustomGuestField, 'FieldType').reverse();
      this.ls.customGuestFields.CustomGuestField.forEach(field => {
        let fieldValue = ''
        if (this.rs.primaryContact && this.rs.primaryContact.ContactCustomFields && this.rs.primaryContact.ContactCustomFields.length > 0) {
          fieldValue = this.rs.primaryContact.ContactCustomFields.filter(x => x.CustomFieldId == field.Id)[0] ? this.rs.primaryContact.ContactCustomFields.filter(x => x.CustomFieldId == field.Id)[0].CustomFieldValue : '';
        }
        if (this.showCustomFieldBasedOnActivity(field.Id)) {
          let validation = this.customValidationRequired(field);
          if (field.FieldType == 'Text Field') {
            this.guestInfoConfig.push({
              type: 'input',
              placeholder: field.FieldName,
              value: fieldValue ? fieldValue : '',
              name: 'customGuestField_' + field.Id.toString(),
              class: 'guest-details__promo-code',
              isFormArray: false,
              appearance: true,
              label:  (validation && validation.length > 0) ? field.FieldName + '*' : field.FieldName,
              validation: validation
            });
          }
          if (field.FieldType == 'Drop Down') {
            let Options = [];
            Options = field.FieldOptions.split(',').map(x => { return { id: x, value: x } });
            Options.splice(0, 0, { id: '', value: field.FieldName })
            this.guestInfoConfig.push({
              type: 'select',
              placeholder: field.FieldName,
              options: Options,
              value: fieldValue ? fieldValue : Options[0].id,
              name: 'customGuestField_' + field.Id.toString(),
              class: 'guest-details__promo-code',
              isFormArray: false,
              appearance: true,
              label:  (validation && validation.length > 0) ? field.FieldName + '*' : field.FieldName,
              isNativeControl: this.ls.isMobileBrowser,
              validation: validation
            });
          }
        }
      });
    }
  }
  showCustomFieldBasedOnActivity(customFieldId) {
    
    let specialMealId  = (this.rs.reservationFormGroup.controls.reservationDetailsForm && this.rs.reservationFormGroup.controls.reservationDetailsForm.value.specialMeal) ? this.rs.reservationFormGroup.controls.reservationDetailsForm.value.specialMeal.Id : -1;
    let activitiesCustomGuestFields = this.customGuestFieldsMappingValidations;
    if (activitiesCustomGuestFields.find(activity => activity.ActivityId == specialMealId)) {
      let activeActivity = activitiesCustomGuestFields.find(activity => activity.ActivityId == specialMealId)
      if (activeActivity.CustomFields.filter(field => field.FieldId === customFieldId && field.AvailableForWebReservation == true)?.length > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false
    }
  }
  customValidationRequired(field) {
    if (this.customFieldMandatory(field)) {
      return [Validators.required];
    } else {
      return [];
    }
  }
  customFieldMandatory(field) {
    let specialMealId  = (this.rs.reservationFormGroup.controls.reservationDetailsForm && this.rs.reservationFormGroup.controls.reservationDetailsForm.value.specialMeal) ? this.rs.reservationFormGroup.controls.reservationDetailsForm.value.specialMeal.Id : -1;
    let activitiesCustomGuestFields = this.customGuestFieldsMappingValidations;
    let CustomFields = activitiesCustomGuestFields.find(activity => activity.ActivityId == specialMealId)?.CustomFields
    if (CustomFields.filter(customField => customField.FieldId === field.Id)?.length > 0) {
      let validations = CustomFields.find(customField => customField.FieldId === field.Id)?.Validations
      return (validations && validations.length > 0)
    } else {
      return false;
    }
  }

  isSwireAndSEAEnv() {
    return (environment.SEAProduction == true && (environment.restaurantIds.filter(x => x == this.ls.restaurantWidgetSettings$.value.RestaurantId).length > 0))
  }

  showSMSRemainder() {
    return (environment.restaurantIdshowSMSRemainder?.filter(restaurantId => restaurantId == this.ls.restaurantWidgetSettings$.value.RestaurantId)?.length > 0);
  }

  addRequiredCustomTermsAndConditions() {
    if (this.ls.operation != operationType.edit && !this.ls.restaurantWidgetSettings$.value.DisableCustomTermsAndConditions) {
      this.guestInfoConfig.push({
        type: 'checkbox',
        placeholder: this.getAgreeTermsAndConditionsText(),
        name: 'agreeTerms',
        class: this.isSwireAndSEAEnv() ? 'guest-details__terms-and-conditions guest-details__display-none' : 'guest-details__terms-and-conditions',
        isFormArray: false,
        validation: [Validators.requiredTrue],
        innerHTMLdata: true,
        value: this.isSwireAndSEAEnv() ? true : false
      })
    }

    if (this.ls.restaurantWidgetSettings$.value.IsSmsReminderSupported) {
      if (this.ls.restaurantWidgetSettings$.value.WidgetCustomization.IsReservationReminderMandatory) {
        this.guestInfoConfig.push({
          type: 'checkbox',
          placeholder: 'SmsMessageReminderText',
          value: true,
          name: 'reservationBySMS',
          class: this.isSwireAndSEAEnv() || this.showSMSRemainder() ? 'guest-details__reservation-by-sms guest-details__display-none' : 'guest-details__reservation-by-sms',
          isFormArray: false,
          disabled: true
        });
      }
      else {
        this.guestInfoConfig.push({
          type: 'checkbox',
          placeholder: 'SmsMessageReminderText',
          value: false,
          name: 'reservationBySMS',
          class: this.isSwireAndSEAEnv() || this.showSMSRemainder() ? 'guest-details__reservation-by-sms guest-details__display-none' : 'guest-details__reservation-by-sms',
          isFormArray: false
        });
      }
    }
    this.guestInfoConfig.push({
      type: 'checkbox',
      placeholder: 'emailReminderText',
      value: false,
      name: 'reservationByEmail',
      class: this.isSwireAndSEAEnv() ? 'guest-details__email-remainder guest-details__display-none' : 'guest-details__email-remainder',
      isFormArray: false
    });

    if (this.ls.operation != operationType.edit  && !this.ls.restaurantWidgetSettings$.value.DisableCustomTermsAndConditions) {
      if (this.ls.restaurantWidgetSettings$.value.WidgetCustomization.CustomTermsOfService && this.ls.restaurantWidgetSettings$.value.WidgetCustomization.CustomTermsOfService.length > 0) {
        this.ls.restaurantWidgetSettings$.value.WidgetCustomization.CustomTermsOfService.forEach((customTerm, index) => {
          this.guestInfoConfig.push({
            type: 'checkbox',
            placeholder: customTerm,
            value: false,
            name: 'customTerm_' + index,
            class: 'guest-details__custom-term',
            isFormArray: false,
            validation: [Validators.requiredTrue],
            innerHTMLdata: true
          });
        });
      }
    }

    if (this.ls.restaurantWidgetSettings$.value.ConfirmationVia == ConfirmationVia.Both) {
      this.guestInfoConfig.push({
        type: 'checkbox',
        placeholder: this.ts.instant('smsConfirmationText'),
        value: false,
        name: 'reservationConfirmationBySMS',
        class: 'guest-details__confirmation-by-sms',
        isFormArray: false
      });
      this.guestInfoConfig.push({
        type: 'checkbox',
        placeholder: this.ts.instant('emailConfirmationText'),
        value: false,
        name: 'reservationConfirmationByEmail',
        class: 'guest-details__confirmation-by-email',
        isFormArray: false
      });
    }

    //Marketing
    if (this.ls.restaurantWidgetSettings$.value.MarketingFlagEnabled && this.ls.restaurantWidgetSettings$.value.MarketingFlagDescription) {
      this.guestInfoConfig.push({
        type: 'checkbox',
        placeholder: this.ls.restaurantWidgetSettings$.value.MarketingFlagDescription,
        value: this.ls.operation == operationType.edit && this.ls.editPartyData$.value.Contact.MarketingOptedIn ? this.ls.editPartyData$.value.Contact.MarketingOptedIn : false,
        name: 'marketingFlag',
        class: 'guest-details__marketing-flag',
        isFormArray: false,
        innerHTMLdata: true
      });
    }

    //Data Retention Policy
    this.dataRetentionPolicyExisting = false;
    if (this.ls.operation != operationType.edit && this.ls.restaurantWidgetSettings$.value.IsGDPREnabled && this.ls.dataRetentionPolicy$.value && this.ls.dataRetentionPolicy$.value.PolicyDetails) {
      for (var i = 0; i < this.ls.dataRetentionPolicy$.value.PolicyDetails.length; i++) {
        var policyDetails = this.ls.dataRetentionPolicy$.value.PolicyDetails[i];
        switch (policyDetails.DataType) {
          case PolicyDataType.Name:
          case PolicyDataType.Address:
          case PolicyDataType.PhoneNumber:
          case PolicyDataType.EmailAddress:
          case PolicyDataType.GuestImage:
          case PolicyDataType.CustomGuestFields:
          case PolicyDataType.BirthdayAndAnniversary:
            if (policyDetails.RetentionInDays > 0) {
              this.dataRetentionPolicyExisting = true;
            }
            break;
          default:
            this.dataRetentionPolicyExisting = false;
            break;

        }
      }
    }
    if (this.dataRetentionPolicyExisting) {
      this.guestInfoConfig.push({
        type: 'checkbox',
        placeholder: this.ts.instant('dataRetentionCheckBoxText') + '<a href="/data_rentention_policy/restaurants/' + this.ls.restaurantWidgetName + '" target="_blank" class="default-hyperlink" >' + this.ts.instant('dataRetentionPolicy') + '</a>.',
        value: false,
        name: 'dataRetention',
        class: 'guest-details__data-retention-policy',
        isFormArray: false,
        innerHTMLdata: true
      });
    }

  }

  showDataRententionPolicy() {
    let dataRetentionPolicyData = {
      customPolicyText: this.ls.restaurantWidgetSettings$.value.CustomPolicyText ? this.ls.restaurantWidgetSettings$.value.CustomPolicyText : this.ts.instant('serverBetter'),
      policyDetails: this.ls.dataRetentionPolicy$.value.PolicyDetails,
      fromClient: false // Need to bind based on Url launched
    }
    const componentDetails: ComponentDetails = Utilities.setComponentDetails(DataRetentionPolicyComponent, 'small', '', dataRetentionPolicyData,
      this.ts.instant('guestConsentPolicy'));
    this.dataRetentionPolicyDialogRef = this.openCustomPopup(componentDetails, ComponentTypes.dataRetentionPolicy, dataRetentionPolicyData.fromClient ? '50%' : '40%', dataRetentionPolicyData.fromClient ? '80%' : '60%', false, this.ts.instant('No'), this.ts.instant('Yes'),
      '', false)
  }

  getAgreeTermsAndConditionsText(): string {
    let text = "";
    if(this.ls.restaurantWidgetSettings$.value.DisableCustomTermsAndConditions){
      text = this.ts.instant('By clicking next, you agree to the terms of use and privacyPolicy', { terms: `<a class="link-url" href="${'/Terms_Of_Use/restaurants/' + this.ls.restaurantWidgetName }" target="_blank">${this.ts.instant('termsOfUse')}</a>`, privacyPolicy: `<a class="link-url" href="${'/Privacy_Policy/restaurants/' + this.ls.restaurantWidgetName}" target="_blank" >${this.ts.instant('privacyPolicy')}</a>`})
    }else{
      text = this.ts.instant('You agree to the terms of use and privacyPolicy', { terms: `<a class="link-url" href="${'/Terms_Of_Use/restaurants/' + this.ls.restaurantWidgetName }" target="_blank">${this.ts.instant('termsOfUse')}</a>`, privacyPolicy: `<a class="link-url" href="${'/Privacy_Policy/restaurants/' + this.ls.restaurantWidgetName}" target="_blank" >${this.ts.instant('privacyPolicy')}</a>`})
    }
    // text = this.ts.instant('agree') + '<a href="/Terms_Of_Use/restaurants/' + this.ls.restaurantWidgetName + '" target="_blank" class="default-hyperlink" >' + this.ts.instant('termsOfUse') + '</a>' + this.ts.instant('and')
    //   + '<a href="/Privacy_Policy/restaurants/' + this.ls.restaurantWidgetName + '" target="_blank" class="default-hyperlink" >' + this.ts.instant('privacyPolicy') + '</a>';
    return text;
  }

  ngAfterViewInit() {
    const allNotes = {};
    for (const addInfo of this.guestInfoConfig) {
      allNotes[addInfo.name] = '';
    }
    this.notesFormGroup = this.fb.group(allNotes);
    if (this.rs.additionalGuestPage && this.ls.operation != operationType.edit) {
      this.guestDetailsForm = this.fb.group({
        secondaryGuest1: this.components.first.form
      })
    }
    else {
      this.rs.primaryContact ? this.bindContactPhoneNumber() : this.components.first.form.controls.phone.setValue(''); //to remove the cuntryId binded as value in the input field
      this.guestDetailsForm = this.fb.group({
        primaryGuest: this.components.first.form,
      })
    }
    if (this.rs.reservationFormGroup.controls.guestDetailsForm) {
      let copyData:boolean = this.ls.restaurantWidgetSettings$?.value?.CopyPrimaryContactDetailsToSecondaryWidget;
      this.components.first.form.controls.phone.setValue('');
      if (this.rs.additionalGuestPage && this.ls.operation != operationType.edit) {
        if(copyData) {
          this.components.first.form.controls.phone.patchValue(this.rs.reservationFormGroup.controls.guestDetailsForm.get('primaryGuest').value.phone);
          this.components.first.form.controls.email.patchValue(this.rs.reservationFormGroup.controls.guestDetailsForm.get('primaryGuest').value.email);
          this.primaryGuestPhone = this.rs.reservationFormGroup.controls.guestDetailsForm.get('primaryGuest').value.phone;
          this.primaryGuestEmail = this.rs.reservationFormGroup.controls.guestDetailsForm.get('primaryGuest').value.email;
        }
       }
      else if (!this.rs.additionalGuestPage && this.ls.operation == operationType.edit) {
        this.primaryGuestPhone = this.rs.reservationFormGroup.controls.guestDetailsForm.get('primaryGuest').value.phone;
        this.primaryGuestEmail = this.rs.reservationFormGroup.controls.guestDetailsForm.get('primaryGuest').value.email;
        this.components.first.form.patchValue(this.rs.reservationFormGroup.controls.guestDetailsForm.get('primaryGuest').value);
        if (this.rs.secondaryContactList && this.rs.secondaryContactList.length > 0) {
          this.components.toArray().forEach((formData, index) => {
            if (index > 0) {
              this.bindContactsToForm(formData.form, this.rs.secondaryContactList[index - 1]);
              let fc = new FormControl(this.rs.secondaryContactList[index - 1].Id);
              formData.form.addControl("id", fc);
            }
          });
          let secondaryContactList = this.buildSecondaryContactList();
          (this.rs.reservationFormGroup.get('guestDetailsForm') as FormGroup).addControl('secondaryContactList', this.fb.array(secondaryContactList.map(contact => this.fb.group(contact))));
        }
      }
      else if (!this.rs.additionalGuestPage && this.ls.operation != operationType.edit) {
        this.components.first.form.patchValue(this.rs.reservationFormGroup.controls.guestDetailsForm.get('primaryGuest').value)
        this.components.first.form?.controls["agreeTerms"]?.setValue(this.isSwireAndSEAEnv() ? true : false, { emitEvent: false });
        if (this.components.first.form.controls["dataRetention"]) {
          this.components.first.form.controls["dataRetention"]?.setValue(false, { emitEvent: false });
        }
        if (this.ls.restaurantWidgetSettings$.value.WidgetCustomization.CustomTermsOfService && this.ls.restaurantWidgetSettings$.value.WidgetCustomization.CustomTermsOfService.length > 0) {
          this.ls.restaurantWidgetSettings$.value.WidgetCustomization.CustomTermsOfService.forEach((customTerm, index) => {
            this.components.first.form?.controls['customTerm_' + index]?.setValue(false, { emitEvent: false });
          });
        }
      }
    }
    else {
      if (this.ls.operation == operationType.edit && !this.rs.additionalGuestPage) {
        this.components.toArray().forEach((formData, index) => {
          if (index == 0) {
            this.bindContactsToForm(formData.form, this.rs.primaryContact);
            this.bindPreferencesCategoryToForm(formData.form, this.ls.editPartyData$.value.Notes);
          }
          else {
            this.bindContactsToForm(formData.form, this.rs.secondaryContactList[index - 1]);
            let fc = new FormControl(this.rs.secondaryContactList[index - 1].Id);
            formData.form.addControl("id", fc);
          }
        });

        this.primaryGuestPhone = this.components.first.form.value.phone;
        this.primaryGuestEmail = this.components.first.form.value.email;
      }
      //this.bindSecondaryContactsToForm();
      this.rs.reservationFormGroup.addControl('guestDetailsForm', this.guestDetailsForm);
      let secondaryContactList = this.buildSecondaryContactList();
      (this.rs.reservationFormGroup.get('guestDetailsForm') as FormGroup).addControl('secondaryContactList', this.fb.array(secondaryContactList.map(contact => this.fb.group(contact))));
    }

    this.subscriptions.add(this.guestDetailsForm.valueChanges.subscribe(data => {
      this.dynamicValidation();
    }));
    this.components.forEach(dynamicForm => {
      this.subscriptions.add(
        dynamicForm.form.valueChanges.subscribe(data => {
          dynamicForm.form.controls.firstName.setValue(dynamicForm.form.controls.firstName.value ? this.titleCasePipe.transform(dynamicForm.form.controls.firstName.value) : dynamicForm.form.controls.firstName.value, { emitEvent: false });
          dynamicForm.form.controls.lastName.setValue(dynamicForm.form.controls.lastName.value ? this.titleCasePipe.transform(dynamicForm.form.controls.lastName.value) : dynamicForm.form.controls.lastName.value, { emitEvent: false });
          dynamicForm.form.controls.aliasName.setValue(dynamicForm.form.controls.aliasName.value ? this.titleCasePipe.transform(dynamicForm.form.controls.aliasName.value) : dynamicForm.form.controls.aliasName.value, { emitEvent: false });
          this.confirmButton.disbaledproperity = dynamicForm.form.invalid || this.isAnyFormInvalid() || !this.isUserAllowedToclickConfirm || !this.checkCustomTermsAndMessageOptionValidation();
        })
      )
    })
    this.subscriptions.add(
      this.gs.languageFileChanges.subscribe(data => {
        if(data){
          let termsIndex = this.guestInfoConfig.findIndex(config => config.name == 'agreeTerms')
          if(termsIndex){
            this.guestInfoConfig[termsIndex].placeholder = this.getAgreeTermsAndConditionsText();
            setTimeout(() =>{
              this.guestInfoConfig[termsIndex].placeholder = this.getAgreeTermsAndConditionsText();
              this.guestInfoConfig = [...this.guestInfoConfig];
            },500)
          }
        }
      })
    )
    // if (this.ls.operation == operationType.edit && this.ls.editPartyData$.value) {
    //   this.getFinancialEffectCalculation();
    // }
  }
  dynamicValidation(){
    this.confirmButton.disbaledproperity = this.guestDetailsForm?.invalid || this.isAnyFormInvalid() || !this.isUserAllowedToclickConfirm || !this.checkCustomTermsAndMessageOptionValidation();
  }

  bindContactPhoneNumber() {
    if (this.ls.editPartyData$.value?.GuestReservationPhoneNumber) {
      this.components.first.form.controls.phone.setValue(this.rs.primaryContact.PhoneNumber2)
    } else {
      this.components.first.form.controls.phone.setValue(this.rs.primaryContact.PhoneNumber)
    }
  }

  termsOfUse() {
    this.ls.nextButton.next(componentName.terms_of_use)
  }

  goBackToReservation() {
    this.resetPaymentInfo();
    if (this.ls.lockResult && this.ls.lockResult.SlotLockIdDTO) {
      this.rs.ReleaseLockSlot(this.ls.restaurantWidgetSettings$.value.RestaurantId, this.ls.lockResult.SlotLockIdDTO.Id).subscribe(data => {
        this.ls.offTimer();
        this.ls.nextButton.next(componentName.reservationDetails);
      });
    } else if (this.ls.operation === operationType.edit && this.ls.editPartyData$.value) {
      this.ls.nextButton.next(componentName.reservationDetails);
    }
  }

  reservationConfirm() {
    this.gs.setMessageState('', 0);
    if (this.rs.additionalGuestPage) {
      this.createSecondaryContacts();
    }
    else {
      let partyDtoRequired = this.buildReservationRequest(true);
      this.rs.reservationFormGroup.setControl('guestDetailsForm', this.guestDetailsForm);
      if (this.ls.operation == operationType.edit && this.ls.editPartyData$.value) {
        if (!this.isPartySizeMatchSecondaryContactList()) {
          this.gs.setMessageState(this.ts.instant('partySizeMisMatchError'), 0);
          return;
        }
        let secondaryContactList = this.buildSecondaryContactList();
        (this.rs.reservationFormGroup.get('guestDetailsForm') as FormGroup).addControl('secondaryContactList', this.fb.array(secondaryContactList.map(contact => this.fb.group(contact))));
        if (this.isAuthRefund) {
          if (this.gs.refundData) {
            partyDtoRequired.refundData = this.gs.refundData;
            this.updateReservation(partyDtoRequired);
          } else {
            this.showAuthRefundPopup();
          }
        } else {
          this.updateReservation(partyDtoRequired);
        }
      } else {
        this.CreateReservation(partyDtoRequired);
      }
    }
  }

  getSeatSelection() {
    if (this.rs.additionalGuestPage) {
      this.ls.nextButton.next(componentName.confirmDetails);
    }
    else {
      this.resetPaymentInfo();
      if (this.ls.restaurantWidgetSettings$.value.WidgetCustomization.AllowTableSelection) {
        this.rs.lockCallRequired = false;
        this.ls.nextButton.next(componentName.tablesLayout)
      }
      else {
        //this.ls.curentComponent= ReservationDetailsComponent;
        this.goBackToReservation();
      }
    }
  }

  trackByGuest(guest: any): number {
    return guest;
  }

  additionalGuest() {
    this.guestData.push(this.ts.instant('secondaryGuest') + (this.guestData.length + 1));
    this.confirmButton.disbaledproperity = true;
    setTimeout(() => {
      this.components.forEach(queryForm => {
        this.subscriptions.add(queryForm.form.valueChanges.subscribe(data => {
          queryForm.form.controls.firstName.setValue(queryForm.form.controls.firstName.value ? this.titleCasePipe.transform(queryForm.form.controls.firstName.value) : queryForm.form.controls.firstName.value, { emitEvent: false });
          queryForm.form.controls.lastName.setValue(queryForm.form.controls.lastName.value ? this.titleCasePipe.transform(queryForm.form.controls.lastName.value) : queryForm.form.controls.lastName.value, { emitEvent: false });
          queryForm.form.controls.aliasName.setValue(queryForm.form.controls.aliasName.value ? this.titleCasePipe.transform(queryForm.form.controls.aliasName.value) : queryForm.form.controls.aliasName.value, { emitEvent: false });
          this.confirmButton.disbaledproperity = queryForm.form.invalid || this.isAnyFormInvalid() || !this.isUserAllowedToclickConfirm || !this.checkCustomTermsAndMessageOptionValidation();
        }))
        let copyData:boolean = this.ls.restaurantWidgetSettings$?.value?.CopyPrimaryContactDetailsToSecondaryWidget;
        if (!queryForm.form.controls.phone.touched && !queryForm.form.controls.firstName.value && !queryForm.form.controls.firstName.touched) {
          queryForm.form.controls.phone.patchValue(copyData ? this.primaryGuestPhone : '', { emitEvent: false });
        }
        if (!queryForm.form.controls.email.touched && !queryForm.form.controls.email.value) {
          queryForm.form.controls.email.patchValue(copyData ? this.primaryGuestEmail : '', { emitEvent: false });
        }
      })
    }, 250);

  }

  isAnyFormInvalid(): boolean {
    let invalidFormCount = 0;
    this.components.toArray().forEach(formData => {
      if (formData.form.invalid) {
        invalidFormCount++;
      }
    })
    return invalidFormCount > 0;
  }

  bindContactsToForm(form, contact) {
    form.controls.firstName.setValue(contact.FirstName);
    form.controls.lastName.setValue(contact.LastName);
    form.controls.aliasName.setValue(contact.AliasName);
    if (this.ls.editPartyData$.value?.GuestReservationPhoneNumber) {
      form.controls.phone.setValue(contact.PhoneNumber2);
    } else {
      form.controls.phone.setValue(contact.PhoneNumber);
    }
    if (this.ls.editPartyData$.value?.GuestReservationEmail) {
      form.controls.email.setValue(contact.EmailAddress2);
    } else {
      form.controls.email.setValue(contact.EmailAddress);
    }
    this.bindPreferencesCategoryToForm(form, contact.Notes);
  }

  bindPreferencesCategoryToForm(form, notes) {
    let Notes = {};
    if (notes && notes.length > 0) {
      notes.forEach(note => {
        Notes[note.RelatedId] = true;
        if (this.freeTextIdList && this.freeTextIdList.length > 0 && this.freeTextIdList.findIndex(Id => Id == note.RelatedId) > -1 && note.Text) {
          if (form.controls[note.RelatedId.toString()]) {
            form.controls[note.RelatedId.toString()].setValue(note.Text);
          }
        }
      })
    }
    if (this.ls.restaurantWidgetSettings$.value.PreferencesCategories && this.ls.restaurantWidgetSettings$.value.PreferencesCategories.length > 0) {
      this.ls.restaurantWidgetSettings$.value.PreferencesCategories.forEach(category => {
        if (form.controls['preferences_' + category.Id.toString()]) {
          form.controls['preferences_' + category.Id.toString()].patchValue([Notes]);
        }
      });
    }
  }

  resetPaymentInfo() {
    this.rs.ispaymentInvolvedInfo = null;
    this.rs.reservationAttemptInfo = null;
  }

  GetPreliminaryReservationInformation() {
    this.rs.GetPreliminaryReservationInformation(this.ls.restaurantWidgetSettings$.value.RestaurantId,
      this.rs.reservationFormGroup.controls.reservationDetailsForm.value.partySize,
      moment(this.rs.reservationFormGroup.controls.reservationDetailsForm.value.reservationTime).format('YYYY-MM-DDTHH:mm:ss'),
      this.rs.reservationFormGroup.controls.reservationDetailsForm.value.specialMeal.Id,
      this.rs.reservationFormGroup.controls.reservationDetailsForm.value.tableId[0],
      this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id > 0 ?
        this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id : null,
      this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id > 0 ?
        this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id : null).subscribe(data => {
          if (data) {
            this.rs.ispaymentInvolvedInfo = data;
            if (this.partyDetails.specialMeal.WaiverFormCode || (this.ls.restaurantWidgetSettings$.value.DefaultWaiverForm && this.ls.restaurantWidgetSettings$.value.DefaultWaiverForm.Applied)) {
              this.isUserAllowedToclickConfirm = false;
              this.LoadGuestWaiverForm(this.partyDetails.specialMeal.WaiverFormCode ? this.partyDetails.specialMeal.WaiverFormCode : this.ls.restaurantWidgetSettings$.value.DefaultWaiverForm.FormCode) // disable confirm button
            }
            else {
              if (this.rs.ispaymentInvolvedInfo.CreditCardRequired) {
                this.isUserAllowedToclickConfirm = false;
                this.RegisterReservationAttempt(true) // diable confirm button
              }
              else {
                this.isUserAllowedToclickConfirm = true; //No payement no waiver form ,guest can create Reservation
                if (this.isSwireAndSEAEnv())
                  this.confirmButton.disbaledproperity = this.guestDetailsForm.invalid || this.isAnyFormInvalid() || !this.isUserAllowedToclickConfirm || !this.checkCustomTermsAndMessageOptionValidation();
              }
            }
            if(this.confirmButton) {
              this.confirmButton.disbaledproperity = this.guestDetailsForm.invalid || this.isAnyFormInvalid() || !this.isUserAllowedToclickConfirm || !this.checkCustomTermsAndMessageOptionValidation();
            }
          }

          else {
            this.isUserAllowedToclickConfirm = false;//Some Error While Processing
          }
          this.dynamicValidation();
        });
  }

  buildReservationRequest(isBookingApiRequest: boolean = false) {
    let remindAboutVisit = false;
    if(this.ls.restaurantWidgetSettings$.value.IsSmsReminderSupported) {
      if(this.ls.restaurantWidgetSettings$.value.WidgetCustomization.IsReservationReminderMandatory) {
        remindAboutVisit = true;
      }else {
        remindAboutVisit = this.guestDetailsForm.value.primaryGuest ? this.guestDetailsForm.value.primaryGuest['reservationBySMS'] : this.ls.editPartyData$.value?.RemindAboutVisit;
      }
    }
    let partyDTO: any = {
      Id: this.ls.operation == operationType.edit ? this.ls.editPartyData$.value?.Id : null,
      Size: this.partyDetails.partySize,
      RemindAboutVisit: remindAboutVisit,// get Value froom form
      RemindAboutVisitEmail: this.guestDetailsForm.value?.primaryGuest?.['reservationByEmail'],//
      AgreedWithTermsOfUse: true,
      Contact: {
        FirstName: this.guestDetailsForm.value?.primaryGuest?.firstName || this.ls.editPartyData$.value?.Contact?.FirstName,
        LastName: this.guestDetailsForm.value?.primaryGuest?.lastName || this.ls.editPartyData$.value?.Contact?.LastName,
        AliasName: this.guestDetailsForm.value?.primaryGuest?.aliasName || this.ls.editPartyData$.value?.Contact?.AliasName,
        EmailAddress: this.guestDetailsForm.value?.primaryGuest?.email || this.ls.editPartyData$.value?.Contact?.EmailAddress,
        PhoneNumber: this.guestDetailsForm.value?.primaryGuest?.phone || this.ls.editPartyData$.value?.Contact?.PhoneNumber,
        PIILastUsedDate: moment(new Date()).format('YYYY-MM-DDTHH:mm:ss'),
        ContactCustomFields: this.getCustomGuestFieldsValue(),
        CountryId: this.rs.selectedCountryId, // map country code
        Notes: this.noteType == NoteType.guestNote ? this.getCategoryPreferencesNotes(this.guestDetailsForm.value?.primaryGuest, NoteType.guestNote) : [],
        MarketingOptedIn: this.guestDetailsForm.value?.primaryGuest?.marketingFlag ? this.guestDetailsForm.value.primaryGuest.marketingFlag : (this.ls.operation == operationType.edit && (!this.ls.restaurantWidgetSettings$.value.MarketingFlagEnabled || !this.ls.restaurantWidgetSettings$.value.MarketingFlagDescription) && this.ls.editPartyData$.value?.Contact.MarketingOptedIn) ? this.ls.editPartyData$.value.Contact.MarketingOptedIn : null
      },
      Slot: {
        Time: moment(this.partyDetails.reservationTime).format('YYYY-MM-DDTHH:mm:ss'),
        LockId: this.ls.operation == operationType.edit && !this.ls.lockResult ? null : this.ls.lockResult.SlotLockIdDTO.Id,
        Type: 4 //"AutodetectSlot"
      },
      PartyId: this.ls.operation == operationType.edit ? this.ls.editPartyData$.value.Id : null,
      SeatingAreaId: this.partyDetails.seatingArea.id > 0 ? this.partyDetails.seatingArea.id : null,
      SpecialMealId: this.partyDetails.specialMeal.Id,
      SeatingTypeId: this.partyDetails.seatingType.id > 0 ? this.partyDetails.seatingType.id : null,
      ConfirmationMessageOption: this.getConfirmationMessageOption(),
      Notes: this.noteType == NoteType.partyNote ? this.getPartyNotes() : this.getNotes(),
      TableIds: this.partyDetails.tableId && this.partyDetails.tableId.length > 0 ? this.partyDetails.tableId : [],
      CoverTypes: this.getCoverTypes(),//Bind Cover types
      BookingTypes: this.getBookingTypes(),//Bind Booking types
      IsCommunalTable: this.partyDetails.communalAvailability || this.ls.isCommunalTableSelected,
      FromWebsite: true,
      Language: this.ls.language, // get language id
      ReservationAttemptId: this.rs.reservationAttemptInfo && this.rs.reservationAttemptInfo.ReservationAttemptId ? this.rs.reservationAttemptInfo.ReservationAttemptId : null,
      waiverFormTransactionId: this.waiverFormTrancationId ? this.waiverFormTrancationId : (this.ls.operation == operationType.edit && this.ls.editPartyData$.value.WaiverFormTransactionId) ? this.ls.editPartyData$.value.WaiverFormTransactionId : null,
      BookingContacts: this.ls.operation == operationType.edit ? this.buildSecondaryContactList() : null,
      isBookingApiRequest,
      LanguageId: Number(sessionStorage.getItem('languageId')),
      AuthorizeTransaction : this.authorizeTransactionDetails
    };

    if (this.ls.operation != operationType.edit && this.guestDetailsForm.value?.primaryGuest?.dataRetention) {
      partyDTO.Contact.ConsentDate = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss');
      partyDTO.Contact.ConsentPolicyId = this.ls.dataRetentionPolicy$.value.Id;
    }

    return partyDTO;
  }

  getNotes() {
    let notes = [];
    //Map Promocode Value
    let promoCodeValue = '';
    if (this.ls.restaurantWidgetSettings$.value.WidgetCustomization.DisplayPromoCode) {
      promoCodeValue = this.guestDetailsForm?.value?.primaryGuest?.promocode || this.ls.editPartyData$.value?.Notes?.find(note => note.Type == PartyNoteType.PromoCode)?.Text;
      if (promoCodeValue) {
        let promoCode = { Type: 3, Text: promoCodeValue };
        notes.push(promoCode);
      }
    }
    return notes;
  }

  getPartyNotes() {
    let promoCodeNotes = this.getNotes();
    let partyNotes = this.getCategoryPreferencesNotes(this.guestDetailsForm.value.primaryGuest, NoteType.partyNote);

    return promoCodeNotes.concat(partyNotes);
  }

  getConfirmationMessageOption() {
    if (this.ls.restaurantWidgetSettings$.value.ConfirmationVia == ConfirmationVia.Both) {
      if (this.guestDetailsForm.value.primaryGuest['reservationConfirmationByEmail']
        && this.guestDetailsForm.value.primaryGuest['reservationConfirmationBySMS']) {
        return ConfirmationVia.Both;
      }
      else if (this.guestDetailsForm.value.primaryGuest['reservationConfirmationByEmail']) {
        return ConfirmationVia.Email;
      }
      else if (this.guestDetailsForm.value.primaryGuest['reservationConfirmationBySMS']) {
        return ConfirmationVia.Sms;
      }
      else {
        return this.ls.restaurantWidgetSettings$.value.ConfirmationVia;
      }
    }
    else {
      return this.ls.restaurantWidgetSettings$.value.ConfirmationVia;
    }
  }

  getContactNotes() {
    return [];
  }

  getCustomGuestFieldsValue() {
    let CustomFieldsList: CustomFieldsDTO[] = [];
    if (this.ls.customGuestFields && this.ls.customGuestFields.CustomGuestField.length > 0) {
      this.ls.customGuestFields.CustomGuestField.forEach(field => {
        let fieldValue = ''
          
        if (this.guestDetailsForm.value.primaryGuest && this.guestDetailsForm.value.primaryGuest['customGuestField_' + field.Id.toString()]) {
          fieldValue = this.guestDetailsForm.value.primaryGuest['customGuestField_' + field.Id.toString()];
        }else if (this.rs.primaryContact && this.rs.primaryContact.ContactCustomFields && this.rs.primaryContact.ContactCustomFields.length > 0) {
          fieldValue = this.rs.primaryContact.ContactCustomFields.filter(x => x.CustomFieldId == field.Id)[0] ? this.rs.primaryContact.ContactCustomFields.filter(x => x.CustomFieldId == field.Id)[0].CustomFieldValue : '';
        }
          
        let customField = new CustomFieldsDTO();
        customField.CustomFieldId = Number(field.Id);
        customField.CustomFieldValue = fieldValue;
        customField.CustomFieldName =  field.FieldName;
        CustomFieldsList.push(customField);
        
      })
    }
    return CustomFieldsList;
  }

  getCoverTypes(): CoverTypeQuantityDTO[] {
    let coverTypesList: CoverTypeQuantityDTO[] = [];
    if (this.rs.reservationFormGroup.controls.reservationDetailsForm.value.specialMeal &&
      this.rs.reservationFormGroup.controls.reservationDetailsForm.value.coverTypes &&
      this.rs.reservationFormGroup.controls.reservationDetailsForm.value.specialMeal.CoverTypePrices) {
      this.rs.reservationFormGroup.controls.reservationDetailsForm.value.specialMeal.CoverTypePrices.forEach(coverType => {
        let coverTypeDto = new CoverTypeQuantityDTO();
        coverTypeDto.CoverTypeId = coverType.Id;
        coverTypeDto.CoverTypeName = coverType.CoverTypeName;
        coverTypeDto.Covers = this.rs.reservationFormGroup.controls.reservationDetailsForm.value.coverTypes[coverType.Id.toString()];
        coverTypesList.push(coverTypeDto);
      });
    }
    return coverTypesList;
  }

  getBookingTypes(): BookingTypeQuantityDTO[] {
    let bookingTypesList: BookingTypeQuantityDTO[] = [];
    if (this.rs.reservationFormGroup.controls.reservationDetailsForm.value.specialMeal &&
      this.rs.reservationFormGroup.controls.reservationDetailsForm.value.bookingTypes &&
      this.rs.reservationFormGroup.controls.reservationDetailsForm.value.specialMeal.BookingTypeActivitiesMappings) {
      this.rs.reservationFormGroup.controls.reservationDetailsForm.value.specialMeal.BookingTypeActivitiesMappings.forEach(bookingType => {
        let bookingTypeDto = new BookingTypeQuantityDTO();
        bookingTypeDto.BookingTypeId = bookingType.Id;
        bookingTypeDto.BookingTypeName = bookingType.CoverTypeName;
        bookingTypeDto.BookingTypes = this.rs.reservationFormGroup.controls.reservationDetailsForm.value.bookingTypes[bookingType.Id.toString()]
        bookingTypesList.push(bookingTypeDto);
      });
    }
    return bookingTypesList;
  }

  updateReservation(partyDto) {
    this.gs.byPassValidation = false;
    this.rs.UpdateReservation(this.ls.restaurantWidgetSettings$.value.RestaurantId, partyDto, this.gs.allowOverlapBookings).subscribe(data => {
      if (data) {
        this.ls.offTimer();
        this.rs.reservationConfimationDetails = data;
        this.ls.reservationToken = data.Token;
        this.rs.reservationConfirmationText = 'reservationUpdateConfirmationText';
        this.rs.additionalGuestRequired = 0;
        this.authorizeTransactionDetails = null;
        this.ls.getByToken(data.Token).subscribe(data => {
          this.ls.editPartyData$.next(data);
          this.ls.nextButton.next(componentName.confirmDetails);
        });

      }
    });
  }

  CreateReservation(partyDto) {
    this.gs.byPassValidation = false;
    this.rs.CreateReservation(this.ls.restaurantWidgetSettings$.value.RestaurantId, partyDto, this.gs.allowOverlapBookings).subscribe(data => {
      if (data) {
        this.ls.offTimer();
        this.rs.reservationConfirmationText = 'reservationConfirmationText';
        this.rs.reservationConfimationDetails = data;
        this.ls.reservationToken = data.Token;
        this.rs.additionalGuestRequired = this.partyDetails.partySize - 1;
        this.authorizeTransactionDetails = null;
        this.gs.overlapBookingproceedEvent.next({})
        this.ls.getByToken(data.Token).subscribe(data => {
          this.ls.editPartyData$.next(data);
          this.ls.nextButton.next(componentName.confirmDetails);
        });

      }
    });
  }

  RegisterReservationAttempt(isIframeToBeDisplayed: boolean) {
    let registerReservationAttemptRequestDTO = {
      LocalTime: moment(this.partyDetails.reservationTime).format('YYYY-MM-DDTHH:mm:ss'),  //selected date and time
      PartySize: this.rs.reservationFormGroup.controls.reservationDetailsForm.value.partySize,
      SeatingAreaId: this.partyDetails.seatingArea.id > 0 ? this.partyDetails.seatingArea.id : null,
      SeatingTypeId: this.partyDetails.seatingType.id > 0 ? this.partyDetails.seatingType.id : null,
      TableId: this.partyDetails.tableId && this.partyDetails.tableId.length > 0 ? this.partyDetails.tableId : [],
      SpecialMealId: this.partyDetails.specialMeal.Id,
      CoverTypes: this.getCoverTypes(),
      BookingTypes: this.getBookingTypes(),
      IsCommunalTable: this.partyDetails.communalAvailability || this.ls.isCommunalTableSelected,
      FromWebsite: true,
      PartyId: this.ls.operation == operationType.edit && this.ls.editPartyData$.value ? this.ls.editPartyData$.value.Id : null
    }
    this.rs.RegisterReservationAttempt(this.ls.restaurantWidgetSettings$.value.RestaurantId, registerReservationAttemptRequestDTO).subscribe(data => {
      if (data) {
        this.paymentData = this.rs.reservationAttemptInfo = data;
        this.serviceCharge = this.paymentData.ServiceChargeAmount || 0;
        this.taxOnServiceCharge = this.paymentData.TaxOnServiceChargeAmount ? this.paymentData.TaxOnServiceChargeAmount : (this.paymentData.ServiceCharges && this.paymentData.ServiceCharges.length) ? _.sumBy(this.paymentData.ServiceCharges ,'TaxOnBookingChargeAmount') : (this.paymentData.TaxOnServiceChargeAmount ? this.paymentData.TaxOnServiceChargeAmount : 0)

        this.bindPaymentAmountAndMessage(this.paymentData.RateplanAmountinfo, this.paymentData.SpecialMealAmountinfo, this.paymentData.PaymentAmount, this.paymentData.TaxAmount,this.serviceCharge,this.taxOnServiceCharge)
        if (data.ShouldCreditCardBeEntered && isIframeToBeDisplayed) {
          if (this.rs.reservationAttemptInfo.CreditCardIFrameURL) {
            this.LoadIframe(this.rs.reservationAttemptInfo.CreditCardIFrameURL);
          }
          else {
            this.gs.setMessageState(this.ts.instant('SorryForPaymentOffline'), 0);
          }
        }
        if (this.ls.operation == operationType.edit && this.ls.editPartyData$.value) {
          this.getFinancialEffectCalculation();
        }
      }
    })

  }

  bindPaymentAmountAndMessage(ratePlanAmount, specialMealAmount, paymentAmount, taxAmount?,serviceCharge?,taxOnServiceCharge?) {
    this.ratePlanAmountInfo = ratePlanAmount;
    this.specialMealAmountInfo = specialMealAmount;
    this.paymentAmountInfo = paymentAmount;
    if (ratePlanAmount > 0 || specialMealAmount > 0) { //Activity Payment Involved
      this.activityPayment = ratePlanAmount > 0 ? ratePlanAmount : 0;
      this.activityPayment = specialMealAmount > 0 ? this.activityPayment + specialMealAmount : this.activityPayment;
      this.activityPayment = Number(this.activityPayment);
      this.paymentWithoutTax = _.cloneDeep(this.activityPayment).toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
      this.activityPayment = (this.activityPayment + (taxAmount || 0) + ( serviceCharge|| 0) + ( taxOnServiceCharge|| 0)).toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
      
      if (this.isSelectedMealDefferedPayment()) {
        this.paymentMessage = this.ts.instant('PrePaidMealReservationAuthorize');
      }
      else {
        this.paymentMessage = this.ts.instant('CardWillBeChargedTotalPrePaidReservation');
      }
      this.rs.showPaymentSummary = true;
    }
    else if (paymentAmount > 0) {//noShow
      this.noShowfee = paymentAmount > 0 ? paymentAmount : 0;
      if (this.ls.restaurantWidgetSettings$.value.WidgetCustomization.CustomNoShowFeeTerms) {
        this.noShowfeeMessage = this.ls.restaurantWidgetSettings$.value.WidgetCustomization.CustomNoShowFeeTerms
        this.noShowPolicyTitle = this.ls.restaurantWidgetSettings$.value.CancellationTitle ? this.ls.restaurantWidgetSettings$.value.CancellationTitle : this.ts.instant('noShowPolicy');
      }
      else {
        this.noShowfeeMessage = this.ts.instant('RestaurantCreditCardAssurance');
      }
      this.rs.showPaymentSummary = true;
    }

  }

  @HostListener('window:message', ['$event'])
  onMessage({ origin, data }) {
    if (origin != environment.authorizeIframeResponseOrigin && origin != environment.rGuestPayIframeResponsOrigin) { // set your origin
      return false;
    }
    var rGuestPayResponse = data;
    var payResponse = data;
    if (typeof data != "object") {
      rGuestPayResponse = JSON.parse(data);
    }
    if ((data.type == "txn-completed" && data.transactionInfo && data.transactionInfo.transactionInfo && data.transactionInfo.transactionInfo.payments) || (rGuestPayResponse && (rGuestPayResponse.code || rGuestPayResponse.gatewayResponseData))) {

      if (data && data.transactionInfo && data.transactionInfo.transactionInfo.successCode == 1 && data.transactionInfo.transactionInfo.payments.length > 0 && data.transactionInfo.transactionInfo.payments[0].paymentType == 7) { //Waiver form
        this.proceedReservation(data.transactionInfo.transactionInfo.payments[0].authorizeTransactionID);
        return;
      }

      if (this.paymentData.PaymentGateway == PaymentGateways.AuthorizePay) { //Authorize Pay
        var transInfo = payResponse.transactionInfo.transactionInfo;
        // var cardInfo = transInfo.saleResponse.cardInfo;
        // var gatewayResponseData = transInfo.saleResponse.gatewayResponseData;
        // var transactionReferenceData = transInfo.saleResponse.transactionReferenceData;
        // var transactionResponseData = transInfo.saleResponse.transactionResponseData;

        if (transInfo.errorMessage || transInfo.successCode != 1) {
          if (transInfo.errorMessage) {
            this.gs.setMessageState(transInfo.errorMessage, 0);
          }
          // else if (gatewayResponseData.message) {
          //   this.gs.setMessageState(gatewayResponseData.message, 0);
          // }
          else {
            this.gs.setMessageState(this.ts.instant("CardInformationProcessNotCompleted"), 0);
          }
        }
        else if (payResponse && transInfo && transInfo.successCode == 1) {
          if (transInfo.payments && transInfo.payments.length > 0 && transInfo.payments[0].paymentType == 7) { //Waiver form
            this.proceedReservation(transInfo.payments[0].authorizeTransactionID);
            return;
          }
          var transactions = this.processTransactions(transInfo);
          var dto = {
            RestaurantId: this.ls.restaurantWidgetSettings$.value.RestaurantId,
            PartyId: this.ls.editPartyData$.value?.Id ? this.ls.editPartyData$.value?.Id : null,
            SlotLockIds: [this.ls.lockResult.SlotLockIdDTO?.Id],
            BookingID: null,
            TokenType: "",
            PayResponse : data.transactionInfo.transactionInfo?.payments[0]?.rGuestPayResponseData,
            PaymentAmount: transInfo.paidAmount,
            PaymentGateway: this.paymentData.PaymentGateway,
            AuthorizeTransactions: transactions,
            ReservationAttemptId: this.paymentData.ReservationAttemptId,
            ReservationAttemptIds: this.paymentData.Slots?.filter(x => x.ReservationAttemptId > 0).map(x => x.ReservationAttemptId),
            SplitPaymentReload: this.isSplitPayment
          };

          if(transactions?.every(e=>e.PaymentType == AuthorizePaymentType.CreditCardToken)){
            this.authorizeTransactionDetails = transactions[0];
            this.isUserAllowedToclickConfirm = true;
            if (this.guestDetailsForm.invalid || !this.checkCustomTermsAndMessageOptionValidation()) {
              this.gs.setMessageState(this.ts.instant('completeAllFields'), 0);
              this.showIframe = false;
              this.isFormValid = false;
            }
            else {
              this.reservationConfirm();
            }

            return;
          }else{
            this.UpdateReservationAttempt(dto);
          }
          // var callbackDto = this.getPaymentCallbackRequestDTO(cardInfo, transactionReferenceData, transInfo, transactionResponseData, this.paymentData.PaymentGateway);
          // this.UpdateReservationAttempt(callbackDto);
        } else {
          this.gs.setMessageState(this.ts.instant("CardInformationProcessNotCompleted"), 0);
        }
      }
      else {
        if (rGuestPayResponse && typeof rGuestPayResponse.code == 'undefined' && typeof rGuestPayResponse.gatewayResponseData == 'undefined' && typeof rGuestPayResponse.token == 'undefined') {
          return;
        }
        else if (rGuestPayResponse.code && rGuestPayResponse.code != "100") {
          rGuestPayResponse = JSON.parse(data);
          if (rGuestPayResponse.validationErrors && rGuestPayResponse.validationErrors.length > 0) {
            var errorString = "";
            rGuestPayResponse.validationErrors.forEach(function (error, i, arr) {
              errorString = error.fieldName + " " + error.value + "\n";
            })
            this.gs.setMessageState(errorString, 0);
          }
          else if (rGuestPayResponse && rGuestPayResponse.gatewayResponseData && rGuestPayResponse.gatewayResponseData.message) {
            alert(rGuestPayResponse.gatewayResponseData.message);
          }
          else {
            this.gs.setMessageState(this.ts.instant("CardInformationProcessNotCompleted"), 0);
          }
        }
        else if (rGuestPayResponse && rGuestPayResponse.gatewayResponseData && rGuestPayResponse.gatewayResponseData.code == "100") {
          let callbackDto = {
            ReservationAttemptId: this.paymentData.ReservationAttemptId,
            CardNumber: rGuestPayResponse.cardInfo.accountNumberMasked,
            ExpirationDate: new Date(data.cardInfo.expirationYearMonth.substring(0, 4) + '-' + data.cardInfo.expirationYearMonth.substring(4) + '-01'),
            CVC: "",
            FirstNameHolder: "",
            LastNameHolder: "",
            AddressLine1: "",
            AddressLine2: "",
            City: "",
            State: "",
            PostalCode: "",
            TokenType: "",
            Token: data.token
          };
          this.UpdateReservationAttempt(callbackDto);
        }
        else {
          this.gs.setMessageState(this.ts.instant("CardInformationProcessNotCompleted"), 0);
        }
      }
    }
    else if (data.type == "txn-completed" && data.transactionInfo) {
      //this.proceedReservation(data.transactionInfo.transactionInfo.authorizeTransactionID);
    } else {
      //Show Error Message
    }
  }

  proceedReservation(waiverFormTrancationId) {
    this.showIframe = false;
    this.isFormValid = false;
    this.waiverFormTrancationId = waiverFormTrancationId;
    //let invoiceId = data.transactionInfo.transactionInfo.invoiceID
    if (this.rs.ispaymentInvolvedInfo && this.rs.ispaymentInvolvedInfo.CreditCardRequired) {
      this.isUserAllowedToclickConfirm = false;
      if (this.rs.reservationAttemptInfo) {
        if (this.rs.reservationAttemptInfo.CreditCardIFrameURL) {
          this.LoadIframe(this.rs.reservationAttemptInfo.CreditCardIFrameURL)
        }
        else {
          this.gs.setMessageState(this.ts.instant('SorryForPaymentOffline'), 0);
        }
      }
      else {
        this.RegisterReservationAttempt(true);
      }
    }
    else {
      this.isUserAllowedToclickConfirm = true;
      if (this.guestDetailsForm.invalid || !this.checkCustomTermsAndMessageOptionValidation()) {
        this.gs.setMessageState(this.ts.instant('completeAllFields'), 0);
        this.showIframe = false;
        this.isFormValid = false;
      }
      else {
        this.reservationConfirm();
      }
    }
  }

  processTransactions(transInfo) {
    //var authTransactionID = transInfo.authorizeTransactionID;
    //var paymentType = transInfo.paymentType;
    //var totalAmount = transInfo.paidAmount;
    //var overAllStatus = transInfo.status;
    //var successCode = transInfo.successCode;
    //var errorCode = transInfo.errorCode;
    //var errorMessage = transInfo.errorMessage;
    var transactions = transInfo.payments;
    var authorizeTransactions = [];

    if (transactions && transactions.length > 0) {
      transactions.forEach(transaction => {
        if (transaction.successCode == 1) {
          var name = '';
          var paymentDetail = transaction.paymentDetail;
          var roomDetails = {
            RoomNumber: null,
            ConfirmationNumber: null,
            LastName: null
          };
          var pointsDetails = {
            AccountNumber: null,
            BucketName: null,
            Name: null,
            LoyaltyTransactionId: null
          };

          if (transaction.paymentType == 1 || transaction.paymentType == 2) { //credit card
            name = paymentDetail.accountName;
          }

          if (transaction.paymentType == 3) { //Post to room charges
            roomDetails.RoomNumber = paymentDetail.cardIssuer;
            roomDetails.ConfirmationNumber = paymentDetail.cardNumber;
            roomDetails.LastName = paymentDetail.accountName;
            name = paymentDetail.accountName;
          }
          if (transaction.paymentType == 5) { //Loyalty
            pointsDetails.BucketName = paymentDetail.tender;
            pointsDetails.AccountNumber = paymentDetail.cardNumber;
            pointsDetails.Name = paymentDetail.accountName;
            pointsDetails.LoyaltyTransactionId = paymentDetail.followOnData;
            name = paymentDetail.accountName;
          }
          var dto = {
            CardNumber: paymentDetail.cardNumber ? paymentDetail.cardNumber : "",
            ExpirationDate: paymentDetail.expirationDate ? paymentDetail.expirationDate.substring(0, 4) + paymentDetail.expirationDate.substring(4) : "",
            Name: name ? name : "",
            Token: paymentDetail.token ? paymentDetail.token : null,
            TransactionFollowOnData: paymentDetail.followOnData ? paymentDetail.followOnData : null,
            AuthorizeTransactionID: transaction.authorizeTransactionID,
            Amount: transaction.paidAmount,
            PaymentType: transaction.paymentType ? transaction.paymentType : null,
            InvoiceID: transaction.invoiceID ? transaction.invoiceID : null,
            TransactionDate: transaction.transactionsDate ? transaction.transactionsDate : null,
            RoomNumber: roomDetails && roomDetails.RoomNumber ? roomDetails.RoomNumber : null,
            ConfirmationNumber: roomDetails && roomDetails.ConfirmationNumber ? roomDetails.ConfirmationNumber : null,
            BucketName: pointsDetails && pointsDetails.BucketName ? pointsDetails.BucketName : null,
            LoyaltyAccountNumber: pointsDetails && pointsDetails.AccountNumber ? pointsDetails.AccountNumber : null,
            LoyaltyTransactionId: pointsDetails && pointsDetails.LoyaltyTransactionId ? pointsDetails.LoyaltyTransactionId : null,
            IssuerType: pointsDetails && paymentDetail.tender ? paymentDetail.tender : null,
            AuthCode : paymentDetail?.authCode,
            CCType : paymentDetail?.cardIssuerType,
            CCTransactionId : paymentDetail?.payTransactionID,
          };
          authorizeTransactions.push(dto);
        } else if (transaction.errorMessage) {
          this.gs.setMessageState(transaction.errorMessage, 0);
        }
      });
      return authorizeTransactions;
    }
  }

  LoadGuestWaiverForm(formCode) {
    this.rs.GetAuthWaiverForm(this.ls.restaurantWidgetSettings$.value.RestaurantId, formCode).subscribe(data => {
      if (data) {
        this.LoadIframe(data.formURL);
        if (this.rs.ispaymentInvolvedInfo && this.rs.ispaymentInvolvedInfo.CreditCardRequired) {
          this.RegisterReservationAttempt(false);
        }
      }
      else {
        this.ls.message = this.ts.instant('somethingWentWrong');
      }
    });
  }

  checkCustomTermsAndMessageOptionValidation() {
    let isApproved = true;
    if (this.rs.additionalGuestPage) {
      return true;
    }

    if (this.ls.restaurantWidgetSettings$.value.ConfirmationVia == ConfirmationVia.Both && !this.guestDetailsForm.value.primaryGuest['reservationConfirmationByEmail']
      && !this.guestDetailsForm.value.primaryGuest['reservationConfirmationBySMS']) {
      isApproved = false;
    }
    return isApproved;
  }

  isPartySizeMatchSecondaryContactList(): boolean {
    if (this.ls.operation == operationType.edit && this.ls.editPartyData$.value.BookingContacts && this.ls.editPartyData$.value.BookingContacts.length > 0 && this.partyDetails.partySize < this.components?.toArray().length) {
      return false;
    }
    else {
      return true;
    }
  }

  LoadIframe(iframeURl: string) {
    if (iframeURl) {
      this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(iframeURl + "&origin=" + window.location.origin)
      this.showIframe = true;
      this.isFormValid = !this.ls.restaurantWidgetSettings$?.value?.DisableCustomTermsAndConditions ? true : false;
    }
    else {
      this.ls.message = this.ts.instant('somethingWentWrong');
    }
  }

  getPaymentCallbackRequestDTO(cardInfo: any, transactionReferenceData: any, transInfo: any, transactionResponseData: any, paymentGateway: PaymentGateways) {
    let paymentCallbackRequestDTO = {
      RestaurantId: this.ls.restaurantWidgetSettings$.value.RestaurantId,
      ReservationAttemptId: this.paymentData.ReservationAttemptId,
      CardNumber: cardInfo.accountNumberMasked,
      ExpirationDate: cardInfo.expirationYearMonth.substring(0, 4) + '-' + cardInfo.expirationYearMonth.substring(4) + '-01',
      CVC: "",
      FirstNameHolder: "",
      LastNameHolder: "",
      AddressLine1: "",
      AddressLine2: "",
      City: "",
      State: "",
      PostalCode: "",
      TokenType: "",
      Token: transactionReferenceData ? transactionReferenceData.token : null,
      PaymentAmount: transactionResponseData.totalAmount,
      AuthorizeTransactionID: transInfo ? transInfo.authorizeTransactionID : null,
      PaymentType: transInfo ? transInfo.paymentType : null,
      InvoiceID: transInfo ? transInfo.invoiceID : null,
      PaymentGateway: paymentGateway,
      TransactionFollowOnData: transactionReferenceData ? transactionReferenceData.transactionFollowOnData : null,
      TransactionDate: transInfo.transactionsDate,
      IssuerType: transactionReferenceData && transactionReferenceData.tender ? transactionReferenceData.tender : null,
    }
    return paymentCallbackRequestDTO;
  }

  UpdateReservationAttempt(Dto) {
    this.rs.UpdateReservationAttempt(Dto).subscribe(data => {
      this.gs.setMessageState('', 0);
      if (data && (data.ErrorMessage || data.ExceptionMessage || (data.ValidationMessages && data.ValidationMessages.length > 0) || data.length == 0)) {
        if (data.ErrorMessage && data.ErrorMessage.length > 0) {
          var sorrysomethingwentwromg = this.ts.instant('SorryWeGotSomeErrorWhileProcessing');
          var CCUprocessableTryAgainErrorMessage = this.ts.instant('CCUprocessableTryAgainErrorMessage');
          var ImportantErrorMessage = this.ts.instant('ImportantErrorMessage');
          var CreditCardAuthorizationError = this.ts.instant('CreditCardAuthorizationError');
          var TryAgainMessage = this.ts.instant('TryAgainMessage');
          var CardNumbershouldContainOnlyDigits = this.ts.instant('CardNumbershouldContainOnlyDigits');
          var CardNumberShouldConsists13To16Digits = this.ts.instant('CardNumberShouldConsists13To16Digits');
          var CardNumberShouldNotBlank = this.ts.instant('CardNumberShouldNotBlank');
          var SorryWeGotSomeErrorCardExpired = this.ts.instant('SorryWeGotSomeErrorWhileProcessingCardExpired');
          if (data.ErrorMessage == "Please try it one more time, if the problem repeats, contact to rGuestSeat@Agilysys.com")
            var url = sorrysomethingwentwromg + TryAgainMessage;
          else if (data.ErrorMessage == "We're sorry, but we couldnÃƒÂ¯Ã‚Â¿Ã‚Â½t process your credit card based on the information you provided. Please try again.")
            var url = sorrysomethingwentwromg + CCUprocessableTryAgainErrorMessage;
          else if (data.ErrorMessage == "[IMPORTANT] Some error happens at the moment of database saving. There is a probability that the payment transaction has performed successfully but this fact hasn't been saved properly. Don't try to do it one more time. Please, contact rGuestSeat@Agilysys.com regarding this error")
            var url = sorrysomethingwentwromg + ImportantErrorMessage;
          else if (data.ErrorMessage == "The provided credit card hasn't been authorized succesfully")
            var url = sorrysomethingwentwromg + CreditCardAuthorizationError;
          else if (data.ErrorMessage.indexOf("The card is expired") > 0)
            var url = SorryWeGotSomeErrorCardExpired;
          else if (data.ErrorMessage == "The card number should consist of only digits")
            var url = sorrysomethingwentwromg + CardNumbershouldContainOnlyDigits;
          else if (data.ErrorMessage == "The card number should consist of from 13 to 16 digits")
            var url = sorrysomethingwentwromg + CardNumberShouldConsists13To16Digits;
          else if (data.ErrorMessage == "The card number shouldn't be blank")
            var url = sorrysomethingwentwromg + CardNumberShouldNotBlank;
          else
            var url = sorrysomethingwentwromg + data.ErrorMessage;
          this.gs.setMessageState(url, 0);
        }
        else {
          var url = sorrysomethingwentwromg + TryAgainMessage;
          this.gs.setMessageState(url, 0);
        }
        this.gs.setMessageState(url, 0);
      }
      else if (data.RedirectUrl) {
        this.ls.offTimer();
        this.LoadIframe(data.RedirectUrl);
        this.isSplitPayment = true;
        this.editButton.disbaledproperity = true;
        setTimeout(() => {
          this.gs.setMessageState(this.ts.instant('yourCurrentPaymentOf') + ' ' + this.ls.restaurantWidgetSettings$.value.OperationCurrency + Dto.PaymentAmount.toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits) + this.ts.instant('isProcessedSuccessfullyPleaseProceedToPay') + this.ls.restaurantWidgetSettings$.value.OperationCurrency + data.PendingAmount.toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits) + this.ts.instant('toPlaceYourReservation'), 1);
        }, 1);
        let timer = moment(data.ExtendedSlotLockResultDTO.ExpiresAt).diff(moment(data.ExtendedSlotLockResultDTO.LockedAt), "seconds");
        this.ls.showTimer = true;
        this.ls.runTimer(timer);
      }
      else {
        this.editButton.disbaledproperity = false;
        this.rs.GetRegisterReservationAttempt(this.paymentData.ReservationAttemptId).subscribe(data => {
          if (data && (data.State == PaymentStates.Authorized || data.State == PaymentStates.ChargeCaptured)) {
            this.isUserAllowedToclickConfirm = true;
            if (this.guestDetailsForm.invalid || !this.checkCustomTermsAndMessageOptionValidation()) {
              this.gs.setMessageState(this.ts.instant('completeAllFields'), 0);
              this.showIframe = false;
              this.isFormValid = false;
            }
            else {
              this.reservationConfirm();
            }
          }
          else {
            this.gs.setMessageState(this.ts.instant("CreditCardNotBeProcessed"), 0);
          }
        });
      }
    });
  }

  createSecondaryContacts() {
    let secondaryContactList = this.buildSecondaryContactList();
    (this.rs.reservationFormGroup.get('guestDetailsForm') as FormGroup).addControl('secondaryContactList', this.fb.array(secondaryContactList.map(contact => this.fb.group(contact))));
    this.rs.CreateSecondaryContacts(this.ls.restaurantWidgetSettings$.value.RestaurantId, this.ls.editPartyData$.value.Id, secondaryContactList).subscribe(data => {
      if (data) {
        this.rs.additionalGuestPage = !this.rs.additionalGuestPage
        this.rs.additionalGuestRequired = 0;
        this.ls.getByToken(this.ls.editPartyData$.value.Token).subscribe(data => {
          if (data) {
            this.ls.editPartyData$.next(data);
            this.ls.nextButton.next(componentName.confirmDetails);
          }
        })

      }
    });
  }

  buildSecondaryContactList() {
    let secondaryContactList: SecondaryContactDTO[] = [];
    if(this.components?.length) {
    for (let i = 0; i < this.components.length; i++) {
      let secondaryContact = new SecondaryContactDTO();
      if (this.rs.additionalGuestPage || (!this.rs.additionalGuestPage && this.ls.operation == operationType.edit && i != 0)) {
        let FormValue = this.components.toArray()[i].form.value;
        secondaryContact.FirstName = FormValue.firstName;
        secondaryContact.LastName = FormValue.lastName;
        secondaryContact.AliasName = FormValue.aliasName;
        secondaryContact.EmailAddress = FormValue.email;
        secondaryContact.PhoneNumber = FormValue.phone;
        secondaryContact.PartyId = this.ls.editPartyData$.value.Id;      
        secondaryContact.Id = FormValue.id ? FormValue.id : null;
        secondaryContact.CountryId = FormValue.region;
        secondaryContact.ContactId = FormValue.id ? this.rs.secondaryContactList?.find(sc=>sc.Id == FormValue.id)?.ContactId : null;
        secondaryContact.Notes = this.getCategoryPreferencesNotes(this.components.toArray()[i].form.value, NoteType.guestNote, secondaryContact.Id, true);
        secondaryContactList.push(secondaryContact)
      }
    }
  }
    return secondaryContactList;
  }

  getFinancialEffectCalculation() {
    let partyDTO = this.buildReservationRequest();
    this.rs.GetFinancialEffectCalculation(this.ls.restaurantWidgetSettings$.value.RestaurantId, partyDTO).subscribe(data => {
      if (data) {
        if (!data.TotalAmount) {
          data.TotalAmount = 0;
        }
        if (!data.SpecialMealAmount) {
          data.SpecialMealAmount = 0;
        }
        if (!data.RatePlanAmount) {
          data.RatePlanAmount = 0;
        }
        this.financialData = data;
        if (data.RedirectUrl) {
          this.isSplitPayment = false;
          this.isUserAllowedToclickConfirm = false;
          this.paymentData.ReservationAttemptId = data.ReservationAttemptId;
          this.paymentData.PaymentGateway = data.PaymentGateway;
          this.confirmButton.disbaledproperity = true;
          this.LoadIframe(data.RedirectUrl);
        }
        switch (data.PartyPaymentType) {
          case 0: // NotSupported
            this.gs.setMessageState(this.ts.instant("ReservationBetweenLocationPrePaidNotSupported"), 0);
            this.isUserAllowedToclickConfirm = false;
          this.confirmButton.disbaledproperity = true;
            return;
          case 1: // NoPaymentsInvolved
            // No messaging in this case
            break;
          case 2: // NoEffect
            this.showFinancialEffectPopUp(this.ts.instant('NoChargeOrRefundForThisReservation'));
            break;
          case 3: // NewReservationAttempt
            //paymentIframeRequired = true;
            if (this.isSelectedMealDefferedPayment()) {
              this.popUpMessage = this.ts.instant('yourCardWillBeChargedPriorToYourMealTime');
            } else {
              this.popUpMessage = this.ts.instant('NoRefundYourPrePayment') + ' ' + this.ls.restaurantWidgetSettings$.value.OperationCurrency + data.TotalAmount.toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
            }
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 4: // NoFullRefund
            if (data.TotalAmount != null && (data.TotalAmount > 0)) {
              this.popUpMessage = this.ts.instant('NoRefundYourPrePayment') + ' ' + this.ls.restaurantWidgetSettings$.value.OperationCurrency + data.TotalAmount.toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
            }
            else {
              // There was no prepayment to mention in text (or it was already refunded)
              this.popUpMessage = this.ts.instant('NoChargeOrRefundForThisReservation');
            }
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 5: // FullRefund
            this.popUpMessage = this.ts.instant('CardUsedForOriginalReservationWillBeRefunded') + ' ' + this.ls.restaurantWidgetSettings$.value.OperationCurrency + data.TotalAmount.toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits) + ' ' + this.ts.instant('severBusinessDays');
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 6: // NoFullRefundAndNewReservationAttempt
            if (data.TotalAmount != null && (data.TotalAmount > 0)) {
              this.popUpMessage = this.ts.instant('NoRefundYourPrePayment') + ' ' + this.ls.restaurantWidgetSettings$.value.OperationCurrency + data.PaymentAmount.toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
            }
            else {
              // There was no prepayment to mention in text (or it was already refunded)
              this.popUpMessage = this.ts.instant('noRefundMessage');
            }
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 7: // FullRefundAndNewReservationAttempt
            this.popUpMessage = this.ts.instant('CardUsedForOriginalReservationWillBeRefunded') + ' ' + this.ls.restaurantWidgetSettings$.value.OperationCurrency + data.TotalAmount.toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits) + ' ' + this.ts.instant('severBusinessDays');
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 8: // PartialCharge
            if (this.rs.reservationAttemptInfo.ShouldCreditCardBeEntered) {
              this.popUpMessage = this.ts.instant('CardNeededToUpdateThisReservation') + ' ' + this.ls.restaurantWidgetSettings$.value.OperationCurrency + data.PaymentAmount.toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits) + ' ' + this.ts.instant('enterCreditCard');
            }
            else {
              var msg = data && data.RedirectUrl ? this.ts.instant('PleaseCompleteRemainingPaymentOf') : this.ts.instant('CardUsedForTheOriginalBookingWillCharged');
              this.popUpMessage = msg + ' ' + this.ls.restaurantWidgetSettings$.value.OperationCurrency + data.PaymentAmount.toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
            }
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 9: // PartialRefund
          case 14:
            if (this.financialData.RefundOption && this.financialData.RefundOption.length > 0) {
              this.RefundData = this.financialData.RefundOption;
              if (this.RefundData) {
                this.popUpMessage = this.ts.instant('PleaseSelectRefundStrategyFor') + this.ls.restaurantWidgetSettings$.value.OperationCurrency + data.PaymentAmount.toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
              } else {
                this.popUpMessage = this.ts.instant('Refund request of ') + this.ls.restaurantWidgetSettings$.value.OperationCurrency + data.PaymentAmount.toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits) + this.ts.instant(' has been processed');
              }
            } else {
              this.popUpMessage = this.ts.instant('refundMessage') + this.ls.restaurantWidgetSettings$.value.OperationCurrency + Math.abs(data.PaymentAmount).toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits) + ".<br />" + this.ts.instant('severalDaysMessage');
            }
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 10: // NoShowFeeUpdated
            this.popUpMessage = this.ts.instant('IfDonotShowYouWillBeCharged') + ' ' + this.ls.restaurantWidgetSettings$.value.OperationCurrency + data.TotalAmount.toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 11: // Authorize

            if (data.TotalAmount > 0) {
              this.popUpMessage = this.ts.instant('CardUsedAtBookingWillBeChargedAtMealTime') + ' ' + this.ls.restaurantWidgetSettings$.value.OperationCurrency + data.TotalAmount.toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
              this.showFinancialEffectPopUp(this.popUpMessage);
            }
            break;
          case 12: // Authorize updated

            if (data.TotalAmount > 0) {
              this.popUpMessage = this.ts.instant('CardUsedAtBookingWillBeChargedAtMealTime') + ' ' + this.ls.restaurantWidgetSettings$.value.OperationCurrency + data.TotalAmount.toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
              this.showFinancialEffectPopUp(this.popUpMessage);
           }
            break;
        }
        this.bindPaymentAmountAndMessage(data.RatePlanAmount.toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits), data.SpecialMealAmount.toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits), data.TotalAmount.toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits)) // need to check how to find deferred payment mode
        if (this.rs.reservationAttemptInfo.ShouldCreditCardBeEntered) {
          this.isUserAllowedToclickConfirm = false;
          this.confirmButton.disbaledproperity = true;
          this.LoadIframe(this.rs.reservationAttemptInfo.CreditCardIFrameURL);
        }
        else {
          if (!data.RedirectUrl) {
            this.isUserAllowedToclickConfirm = true;
            this.confirmButton.disbaledproperity = this.ls.restaurantWidgetSettings$.value.WidgetCustomization.ConfirmationVia == ConfirmationVia.Both && !this.guestDetailsForm.value.primaryGuest['reservationConfirmationByEmail'] && !this.guestDetailsForm.value.primaryGuest['reservationConfirmationBySMS'];
          }
        }
      }
    });
  }

  openDeleteConfirmationPopUp(index) {
    this.secondaryGuestTobeDeletedIndex = index;
    const popUpMessage = [{
      confirmationMessage: this.ts.instant('removeGuestConfirmation'),
      dialogTitle: this.ts.instant('removeSecondaryGuest'),
      showAlert: true
    }];
    const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', '', popUpMessage,
      popUpMessage[0].dialogTitle);
    this.deleteSecondaryGuestPopUpRef = this.openCustomPopup(componentDetails, ComponentTypes.deleteSecondaryGuest, '450px', '300px', true, '', this.ts.instant('Yes'),
      this.ts.instant('No'), true)
  }

  deleteSecondaryGuestConfirmed() {
    this.guestData.splice(this.secondaryGuestTobeDeletedIndex, 1);
    this.guestData.forEach((data, index) => {
      if (index != 0) {
        this.guestData[index] = this.ts.instant('secondaryGuest') + (index + 1);
      }
    });
    this.rs.secondaryContactList = this.buildSecondaryContactList();
    this.rs.secondaryContactList.splice((this.secondaryGuestTobeDeletedIndex - 1), 1);
    let data = _.cloneDeep(this.guestData);
    this.guestData = [];
    this.guestData = _.cloneDeep(data);
    setTimeout(() => {
      this.components.toArray().forEach((formData, index) => {
        if (index > 0) {
          this.bindContactsToForm(formData.form, this.rs.secondaryContactList[index - 1]);
        }
      });
      this.rs.secondaryContactList = this.buildSecondaryContactList();
    }, 1);
    this.confirmButton.disbaledproperity = !this.guestDetailsForm.valid;
  }

  showFinancialEffectPopUp(Message: string) {
    const popUpMessage = [{
      confirmationMessage: Message,
      dialogTitle: this.ts.instant('paymentInfo'),
      showAlert: true
    }];
    const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', '', popUpMessage,
      popUpMessage[0].dialogTitle);
    this.financialPopUpRef = this.openCustomPopup(componentDetails, ComponentTypes.financialEffectCalculation, '450px', '300px', true, this.ts.instant('No'), this.ts.instant('ok'),
      this.ts.instant('cancel'), true)
  }

  isSelectedMealDefferedPayment(): boolean {
    let isDeffered = false;
    if (this.rs.reservationFormGroup.get('reservationDetailsForm').get('specialMeal').value) {
      isDeffered = (this.rs.reservationFormGroup.get('reservationDetailsForm').get('specialMeal').value.DoesRequirePrepayment && !this.rs.reservationFormGroup.get('reservationDetailsForm').get('specialMeal').value.ChargeOnBooking) ? true : false;
    }
    return isDeffered;
  }

  showAuthRefundPopup() {
    const popUpMessage = [{
      dialogTitle: this.ts.instant('refundStrategy'),
      popupInput: this.RefundData,
      disabled: true
    }];

    let financialData = {
      FinancialData: this.financialData,
      OperationCurrency: this.ls.restaurantWidgetSettings$.value.OperationCurrency
    }

    const componentDetails: ComponentDetails = Utilities.setComponentDetails(AuthRefundPopupComponent, 'small', '', financialData,
      popUpMessage[0].dialogTitle);
    this.AuthrefundPopupRef = this.openCustomPopup(componentDetails, ComponentTypes.AuthRefundPopup, '700px', '700px', true, '', this.ts.instant('proceed'),
      this.ts.instant('close'), true, '', '', false, true)
    this.isAuthRefund = true;
  }

  enableIframe() {
    if(this.guestDetailsForm.valid) {
    this.isFormValid = this.guestDetailsForm.valid;
    }
    else {
      this.isFormValid = false;
      for(let control in this.guestDetailsForm.get('primaryGuest')['controls']) {
        this.guestDetailsForm.get('primaryGuest')['controls'][control].markAsDirty();
        this.guestDetailsForm.get('primaryGuest')['controls'][control].markAsTouched();
        this.guestDetailsForm.get('primaryGuest')['controls'][control].updateValueAndValidity();
      }
      var formDiv = document.getElementsByClassName('guest-details__reservation-data')[0];
      if(formDiv) {
        formDiv.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
        formDiv = null;
      }
    }
  }

  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}

